import { useParams, useNavigate } from "react-router-dom";
import AppHeader from '../../components/Header/Header.jsx';
import AppLayout from "../../components/layout";
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import BannerSection from "../../components/BannerSection";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Table from 'react-bootstrap/Table';


const cursosData = [
  {
    id: 1,
    title: 'Licenciatura em Análises Clínicas',
    duration: '5 anos',
    description: 'Explore a Licenciatura em Análises Clínicas: ciência, precisão e inovação para garantir diagnósticos confiáveis e cuidados de saúde de qualidade.',
    detalhes: 'Curso focado em anatomia, fisiologia, saúde pública e práticas clínicas. Inclui estágios supervisionados em unidades de saúde.',
    path: '/programas/licenciatura/detalhes-cursos/1',
    images: [
      require('../../assets/ANU_02.jpg'),
      require('../../assets/ANU_02.jpg'),
    ],
    objetivos: [
      'Formar profissionais capacitados para atuar na área da saúde',
      'Desenvolver competências em diagnóstico e tratamento',
      'Promover a saúde pública e preventiva',
      'Preparar para pesquisa científica em saúde'
    ],
    planoCurricularCompleto: {
      "1º Ano": {
        "1º Semestre (16 semanas)": [
          { disciplina: "Biologia Celular e Molecular ", T: 2, TP: 0, P: 2, HS: 4, HSem: 64 },
          { disciplina: "Bioestatística", T: 2, TP: 0, P: 2, HS: 4, HSem: 64 },
          { disciplina: "Introdução à Análises Clínicas", T: 2, TP: 0, P: 2, HS: 4, HSem: 64 },
          { disciplina: "Metodologia de Investigação Científica", T: 2, TP: 0, P: 2, HS: 4, HSem: 64 },
          { disciplina: "Língua Portuguesa ", T: 0, TP: 2, P: 0, HS: 2, HSem: 32 },
          { disciplina: "Histologia e Citologia", T: 0, TP: 2, P: 0, HS: 2, HSem: 32 },
          { disciplina: "Ética e Legislação", T: 0, TP: 2, P: 2, HS: 2, HSem: 32 },
          { disciplina: "Anatomia Humana", T: 2, TP: 0, P: 2, HS: 4, HSem: 64 },
          { disciplina: "Bioquímica ", T: 2, TP: 2, P: 0, HS: 4, HSem: 64 }
        ],
        "2º Semestre (16 semanas)": [
          { disciplina: "Metodologia de Investigação Científica", T: 2, TP: 0, P: 2, HS: 4, HSem: 64 },
          { disciplina: "Tecnologia Básica", T: 3, TP: 0, P: 3, HS: 6, HSem: 96 },
          { disciplina: "Microbiologia e Parasitologia", T: 3, TP: 0, P: 3, HS: 6, HSem: 96 },
          { disciplina: "Fundamentos de Sociologia e Antopologia", T: 2, TP: 0, P: 2, HS: 4, HSem: 64 },
          { disciplina: "Anatomia Humana", T: 2, TP: 0, P: 2, HS: 4, HSem: 64 },
          { disciplina: "Bioquímica", T: 2, TP: 2, P: 0, HS: 4, HSem: 48 }
        ]
      },
      "2º Ano": {
        "3º Semestre (16 semanas)": [
          { disciplina: "Biopatologia", T: 2, TP: 2, P: 2, HS: 6, HSem: 96 },
          { disciplina: "Fisiologia Humana", T: 2, TP: 2, P: 2, HS: 6, HSem: 96 },
          { disciplina: "Farmacologia", T: 2, TP: 2, P: 2, HS: 6, HSem: 96 },
          { disciplina: "Análise de Água e Alimentos", T: 2, TP: 2, P: 0, HS: 6, HSem: 96 },
          { disciplina: "Farmatoxicologia", T: 2, TP: 2, P: 2, HS: 6, HSem: 96 }
        ],
        "4º Semestre (16 semanas)": [
          { disciplina: "Bacteriologia e Virologia", T: 3, TP: 0, P: 3, HS: 6, HSem: 96 },
          { disciplina: "Hematologia", T: 3, TP: 0, P: 3, HS: 6, HSem: 96 },
          { disciplina: "Hemoterapia", T: 2, TP: 2, P: 2, HS: 6, HSem: 96 },
          { disciplina: "Fisiologia Humana", T: 2, TP: 2, P: 0, HS: 4, HSem: 64 },
          { disciplina: "Farmacologia", T: 2, TP: 2, P: 0, HS: 4, HSem: 64 },
          { disciplina: "Epidemiologia", T: 2, TP: 2, P: 0, HS: 4, HSem: 64 },
        ]
      },
      "3º Ano": {
        "5º Semestre (16 semanas)": [
          { disciplina: "Imunologia", T: 2, TP: 2, P: 2, HS: 6, HSem: 96 },
          { disciplina: "Controlo de Qualidade a Amostragem", T: 2, TP: 0, P: 2, HS: 4, HSem: 64 },
          { disciplina: "Tecnologia Instrumental", T: 2, TP: 0, P: 4, HS: 6, HSem: 96 },
          { disciplina: "Biotecnologia", T: 2, TP: 4, P: 0, HS: 6, HSem: 96 },
          { disciplina: "Hemato-Oncologia", T: 2, TP: 2, P: 0, HS: 2, HSem: 64 },
          { disciplina: "Gestão e Tratamento de Dados", T: 2, TP: 2, P: 0, HS: 4, HSem: 64 },
        ],
        "6º Semestre (16 semanas)": [
          { disciplina: "Seminário e Estágio de Medicina Preventiva", T:3, TP: 0, P: 3, HS: 6, HSem: 96 },
          { disciplina: "Seminário e Estágio de Patologia Clínica", T: 2, TP: 0, P: 2, HS: 4, HSem: 64 },
          { disciplina: "Seminário e Estágio de Gestão e Garantia de Qualidade", T: 2, TP: 2, P: 4, HS: 8, HSem: 128 },
          { disciplina: "Seminário e Estágio de Microbiologia Clínica", T: 0, TP: 4, P: 0, HS: 4, HSem: 64 },
          { disciplina: "Seminário e Estágio de Fundamentos de Nutrição", T: 2, TP: 2, P: 0, HS: 2, HSem: 64 },
          { disciplina: "Seminário e Estágio de Métodos Instrumentais de Análises", T: 2, TP: 0, P: 2, HS: 4, HSem: 64 }
        ]
      },
      "4º Ano": {
        "7º Semestre (16 semanas)": [
          { disciplina: "Estágio de Imunologia e Hematoterapia I", T: 2, TP: 2, P: 2, HS: 6, HSem: 96 },
          { disciplina: "Pedagogia e Didáctica", T: 2, TP: 2, P: 2, HS: 6, HSem: 96 },
          { disciplina: "Diagnóstico de Doenças Tropicais Negligenciais", T: 2, TP: 2, P: 2, HS: 6, HSem: 96 },
          { disciplina: "Doenças Emergentes Grandes Endemias e Pandemias", T: 2, TP: 2, P: 2, HS: 6, HSem: 96 },
          { disciplina: "Seminário e Estágio de Métodos Instrumentais de Análises", T: 2, TP: 2, P: 2, HS: 6, HSem: 96 },
        ],
        "8º Semestre (16 semanas)": [
          { disciplina: "Estágio de Imunologia e Hematoterapia II", T:8, TP: 8, P: 8, HS: 24, HSem: 384 },
          { disciplina: "Estatística Inferencial", T: 2, TP: 2, P: 2, HS: 6, HSem: 96 },
        ]
      },
      "5º Ano": {
        "9º Semestre (16 semanas)": [
          { disciplina: "Estágio de Microbiologia Clínica", T: 2, TP: 2, P: 4, HS: 8, HSem: 128 },
          { disciplina: "Estágio de Patologia Clínica", T: 2, TP: 2, P: 4, HS: 8, HSem: 128 },
          { disciplina: "Estágio de Parasitologia I", T: 2, TP: 2, P: 4, HS: 8, HSem: 128 },
          { disciplina: "Estágio Supervisionado em Saúde Pública", T: 2, TP: 2, P: 2, HS: 6, HSem: 96 },
        ],
        "10º Semestre (16 semanas)": [
          { disciplina: "Estágio de Parasitologia II", T:0, TP: 16, P: 0, HS: 16, HSem: 256 },
          { disciplina: "Estágio de Gestão em Laboratório", T: 0, TP: 10, P: 0, HS: 10, HSem: 160 },
          { disciplina: "Monografia", T: 2, TP: 2, P: 0, HS: 4, HSem: 64 },
        ]
      }
    
    },
    requisitos: '12ª Ano concluída',
    linkInscricao: 'https://portalonline.icsgisabelinha.com/Publico/Candidaturas/Candidatura'
  },
  {
    id: 2,
    title: 'Licenciatura em Engenharia Informática',
    duration: '4 anos',
    description: 'Desbrave a Engenharia Informática: inovação digital, tecnologia de ponta e soluções para os desafios do mundo moderno.',
    detalhes: 'Aprenda programação, redes, inteligência artificial e desenvolvimento de software. Projetos práticos e laboratórios equipados.',
    path: '/programas/licenciatura/detalhes-cursos/2',
    images: [
      require('../../assets/ANU_02.jpg'),
      require('../../assets/ANU_02.jpg'),
    ],
    objetivos: [
      'Formar engenheiros informáticos com sólida base técnica',
      'Desenvolver competências em programação e arquitetura de sistemas',
      'Promover o empreendedorismo tecnológico'
    ],
    planoCurricularCompleto: {
      "1º Ano": {
        "1º Semestre (16 semanas)": [
          { disciplina: "Arquitectura De Computadores", T: 0, TP: 2, P: 4, HS: 6, HSem: 96 },
          { disciplina: "Introdução à Ciência dos Computadores", T: 0, TP: 2, P: 4, HS: 6, HSem: 96 },
          { disciplina: "Programação I", T: 0, TP: 2, P: 4, HS: 6, HSem: 96 },
          { disciplina: "Redes e Comunicações I", T: 0, TP: 2, P: 2, HS: 4, HSem: 64 },
          { disciplina: "Matemática I", T: 2, TP: 2, P: 2, HS: 6, HSem: 96 },
          { disciplina: "Tecnologias da Internet I", T: 0, TP: 2, P: 4, HS: 6, HSem: 96 },
          { disciplina: "Metodologia de Investigação Científica", T: 0, TP: 2, P: 2, HS: 4, HSem: 64 }
        ],
        "2º Semestre (16 semanas)": [
          { disciplina: "Tecnologias da Internet II", T: 0, TP: 2, P: 4, HS: 6, HSem: 96 },
          { disciplina: "Redes e Comunicações II", T: 0, TP: 2, P: 4, HS: 6, HSem: 96 },
          { disciplina: "Algoritmos e Estruturas de Dados", T: 2, TP: 2, P: 2, HS: 6, HSem: 96 },
          { disciplina: "Programação II", T: 0, TP: 2, P: 4, HS: 6, HSem: 96 },
          { disciplina: "Matemática II", T: 2, TP: 2, P: 2, HS: 6, HSem: 96 },
          { disciplina: "Estatística descritiva", T: 2, TP: 2, P: 0, HS: 4, HSem: 48 },
          { disciplina: "Metodologia de Investigação Científica", T: 2, TP: 2, P: 0, HS: 4, HSem: 0 }
        ]
      },
      "2º Ano": {
        "3º Semestre (16 semanas)": [
          { disciplina: "Administração de Redes I", T: 0, TP: 2, P: 4, HS: 6, HSem: 96 },
          { disciplina: "Base de Dados ", T: 0, TP: 2, P: 4, HS: 6, HSem: 96 },
          { disciplina: "Programação III  ", T: 0, TP: 2, P: 4, HS: 6, HSem: 96 },
          { disciplina: "Sistema de Multimédia I", T: 0, TP: 2, P: 4, HS: 6, HSem: 96 },
          { disciplina: "Tecnologias de Internet III ", T: 0, TP: 2, P: 4, HS: 6, HSem: 64 },
          { disciplina: "Teoria das Probabilidades e Modelos de Simulação ", T: 2, TP: 4, P: 0, HS: 4, HSem: 96 },
          { disciplina: "Virtualização I", T: 0, TP: 2, P: 4, HS: 6, HSem: 96 }
        ],
        "4º Semestre (16 semanas)": [
          { disciplina: "Administração de Redes II", T: 0, TP: 2, P: 4, HS: 6, HSem: 96 },
          { disciplina: "Sistemas de Gestão de Bases de Dados  ", T: 0, TP: 2, P: 4, HS: 6, HSem: 96 },
          { disciplina: "Programação IV", T: 0, TP: 2, P: 4, HS: 6, HSem: 96 },
          { disciplina: "Sistema de Multimédia II", T: 0, TP: 2, P: 4, HS: 6, HSem: 96 },
          { disciplina: "Tecnologias de Internet IV", T: 0, TP: 2, P: 2, HS: 4, HSem: 64 },
          { disciplina: "Cálculo Financeiro ", T: 2, TP: 2, P: 0, HS: 4, HSem: 64 },
          { disciplina: "Virtualização I", T: 0, TP: 2, P: 4, HS: 6, HSem: 96 },
        ]
      },
      "3º Ano": {
        "5º Semestre (16 semanas)": [
          { disciplina: "Virtualização II", T: 0, TP: 2, P: 4, HS: 6, HSem: 96 },
          { disciplina: "Direito Informático  ", T: 4, TP: 0, P: 0, HS: 4, HSem: 64 },
          { disciplina: "Arquitectura Técnica de Sistemas de Informação Empresarial", T: 2, TP: 4, P: 0, HS: 6, HSem: 96 },
          { disciplina: "Criptografia ", T: 2, TP: 4, P: 0, HS: 6, HSem: 96 },
          { disciplina: "Gestão Empresarial", T: 2, TP: 2, P: 0, HS: 6, HSem: 64 },
          { disciplina: "Modelos de Simulação Computacionais", T: 2, TP: 4, P: 0, HS: 6, HSem: 96 },
          { disciplina: "Gestão e Tratamento de Dados", T: 0, TP: 2, P: 2, HS: 4, HSem: 64 }
        ],
        "6º Semestre (16 semanas)": [
          { disciplina: "Virtualização II", T: 0, TP: 2, P: 4, HS: 6, HSem: 96 },
          { disciplina: "História da Ciência e das Técnicas ", T: 4, TP: 0, P: 0, HS: 4, HSem: 64 },
          { disciplina: "Programação V ", T: 0, TP: 2, P: 4, HS: 6, HSem: 96 },
          { disciplina: "Modelos de Simulação Computacionais ", T: 0, TP: 2, P: 4, HS: 6, HSem: 96 },
          { disciplina: "Segurança Informática ", T: 2, TP: 4, P: 0, HS: 6, HSem: 96 },
        ]
      },
      "4º Ano": {
        "7º Semestre (16 semanas)": [
          { disciplina: "Virtualização III", T: 0, TP: 2, P: 4, HS: 6, HSem: 96 },
          { disciplina: "Sociedade Ética e Deontologia Profissional ", T: 4, TP: 0, P: 0, HS: 4, HSem: 64 },
          { disciplina: "Projecto Global", T: 0, TP: 20, P: 0, HS: 20, HSem: 320 },
        ],
        "8º Semestre (16 semanas)": [
          { disciplina: "Virtualização III", T: 0, TP: 2, P: 4, HS: 6, HSem: 96 },
          { disciplina: "Projecto Global ", T: 0, TP: 10, P: 20, HS: 30, HSem: 480 },
        ]
      }
    },
    requisitos: '12ª Ano concluída',
    linkInscricao: 'https://portalonline.icsgisabelinha.com/Publico/Candidaturas/Candidatura'
  },
  {
    id: 3,
    title: 'Licenciatura em Pedagogia',
    duration: '4 anos',
    description: 'Forme-se em Pedagogia: teoria e prática para educadores dedicados a transformar vidas através da educação.',
    detalhes: 'Aprenda sobre desenvolvimento infantil, metodologias de ensino e gestão educacional. Projetos práticos e estágios em escolas.',
    path: '/programas/licenciatura/detalhes-cursos/3',
    images: [
      require('../../assets/ANU_02.jpg'),
      require('../../assets/ANU_02.jpg'),
    ],
    objetivos: [
      'Formar educadores com uma sólida base teórica e prática.',
      'Desenvolver competências em metodologias de ensino e gestão educacional.',
      'Promover a inclusão e diversidade na educação.'
    ],
    planoCurricularCompleto: {
      "1º Ano": {
        "1º Semestre (16 semanas)": [
          { disciplina: "Ingles I", T: 0, TP: 3, P: 0, HS: 3, HSem: 48 },
          { disciplina: "Informática ", T: 0, TP: 3, P: 0, HS: 3, HSem: 48 },
          { disciplina: "Filosofia Geral", T: 0, TP: 3, P: 0, HS: 3, HSem: 48 },
          { disciplina: "Psicologia Geral ", T: 3, TP: 0, P: 3, HS: 6, HSem: 96 },
          { disciplina: "Pedagogia I", T: 3, TP: 0, P: 3, HS: 6, HSem: 96 },
          { disciplina: "Metodologia de Investigação Científica", T: 2, TP: 0, P: 4, HS: 6, HSem: 96 },
          { disciplina: "Lingua Portuguesa I", T: 0, TP: 3, P: 0, HS: 3, HSem: 48 }
        ],
        "2º Semestre (16 semanas)": [
          { disciplina: "História de Angola", T: 3, TP: 0, P: 3, HS: 6, HSem: 96 },
          { disciplina: "Pedagogia II", T: 3, TP: 0, P: 3, HS: 6, HSem: 96 },
          { disciplina: "Ingles I", T: 0, TP: 3, P: 0, HS: 3, HSem: 48 },
          { disciplina: "Fundamentos da Educação", T: 0, TP: 2, P: 0, HS: 2, HSem: 32 },
          { disciplina: "Sociologia Geral", T: 0, TP: 2, P: 0, HS: 2, HSem: 32 },
          { disciplina: "Metodologia de Investigação Científica", T: 0, TP: 2, P: 0, HS: 2, HSem: 32 },
          { disciplina: "História da Educação", T: 2, TP: 0, P: 4, HS: 6, HSem: 96 },
          { disciplina: "Lingua Portuguesa I", T: 0, TP: 3, P: 0, HS: 3, HSem: 48 },
        ]
      },
      "2º Ano": {
        "3º Semestre (16 semanas)": [
          { disciplina: "Sociologia da Educação", T: 3, TP: 0, P: 3, HS: 6, HSem: 96 },
          { disciplina: "História das Sociedades Africanas ", T: 3, TP: 0, P: 0, HS: 3, HSem: 48 },
          { disciplina: "Didáctica Geral I", T: 2, TP: 0, P: 4, HS: 6, HSem: 96 },
          { disciplina: "Psicologia do Desenvolvimento", T: 3, TP: 0, P: 3, HS: 6, HSem: 96 },
          { disciplina: "Politicas Sociais", T: 3, TP: 0, P: 0, HS: 3, HSem: 48 },
          { disciplina: "Estatística", T: 3, TP: 0, P: 3, HS: 3, HSem: 48 },
          { disciplina: "Filosofia da Educação", T: 3, TP: 0, P: 0, HS: 3, HSem: 48 }
        ],
        "4º Semestre (16 semanas)": [
          { disciplina: "Teorias Contemporáneas de Aprendizagem ", T: 3, TP: 0, P: 3, HS: 6, HSem: 96 },
          { disciplina: "Sistema Nacional de Educação", T: 3, TP: 0, P: 3, HS: 6, HSem: 96 },
          { disciplina: "Psicologia da Educação", T: 2, TP: 0, P: 4, HS: 6, HSem: 96 },
          { disciplina: "Saúde e Higiene Escolar ", T: 3, TP: 0, P: 0, HS: 3, HSem: 48 },
          { disciplina: "Didáctica Geral II", T: 3, TP: 0, P: 3, HS: 6, HSem: 96 },
          { disciplina: "Ética e Deontologia  ", T: 3, TP: 0, P: 0, HS: 3, HSem: 48 },
        ]
      },
      "3º Ano": {
        "5º Semestre (16 semanas)": [
          { disciplina: "Desenvolvimento Curricular", T: 2, TP: 0, P: 4, HS: 6, HSem: 96 },
          { disciplina: "Administração e Gestão Escolar I", T: 2, TP: 0, P: 4, HS: 6, HSem: 96 },
          { disciplina: "Organização Escolar I", T: 3, TP: 0, P: 3, HS: 6, HSem: 96 },
          { disciplina: "Prática Pedagógica I", T: 3, TP: 0, P: 3, HS: 6, HSem: 96 },
          { disciplina: "Economia de Educação", T: 0, TP: 2, P: 0, HS: 2, HSem: 32 },
          { disciplina: "Teoria Geral de Administração", T: 0, TP: 2, P: 0, HS: 2, HSem: 32 },
          { disciplina: "Demografia", T: 0, TP: 2, P: 0, HS: 2, HSem: 32 }
        ],
        "6º Semestre (16 semanas)": [
          { disciplina: "Orientação Escolar Profissional", T: 2, TP: 0, P: 0, HS: 2, HSem: 32 },
          { disciplina: "Administração e Gestão Escolar II", T: 2, TP: 0, P: 4, HS: 6, HSem: 96 },
          { disciplina: "Organização Escolar II", T: 3, TP: 0, P: 3, HS: 6, HSem: 96 },
          { disciplina: "Prática Pedagógica II", T: 3, TP: 0, P: 3, HS: 6, HSem: 96 },
          { disciplina: "Planificação de Gestão em Educação", T: 2, TP: 0, P: 0, HS: 2, HSem: 32 },
          { disciplina: "Anatomia e Fisiologia Humana", T: 2, TP: 0, P: 0, HS: 2, HSem: 32 },
          { disciplina: "Didáctica Especial", T: 2, TP: 0, P: 4, HS: 6, HSem: 96 },
        ]
      },
      "4º Ano": {
        "7º Semestre (16 semanas)": [
          { disciplina: "Diagnóstico do Sistema Educativo", T: 0, TP: 3, P: 0, HS: 3, HSem: 48 },
          { disciplina: "Metodologia de Ensino I ", T: 0, TP: 3, P: 0, HS: 6, HSem: 96 },
          { disciplina: "Legislação Escolar", T: 0, TP: 23, P: 0, HS: 3, HSem: 48 },
          { disciplina: "Tecnologia de Informação e Comunicação Escolar", T: 0, TP: 3, P: 0, HS: 3, HSem: 48 },
          { disciplina: "Seminário de Gestão e Inspecção", T: 0, TP: 3, P: 0, HS: 3, HSem: 48 },
          { disciplina: "Monografia I", T: 3, TP: 0, P: 3, HS: 6, HSem: 96 },
          { disciplina: "Estágio Supervisionado ", T: 3, TP: 0, P: 3, HS: 6, HSem: 96 },
          
        ],
        "8º Semestre (16 semanas)": [
          { disciplina: "Metodologia de Investigação em Educação Escolar", T: 2, TP: 0, P: 0, HS: 2, HSem: 32 },
          { disciplina: "Metodologia de Ensino II", T: 3, TP: 0, P: 3, HS: 6, HSem: 96 },
          { disciplina: "Prática de Inspecção", T: 0, TP: 3, P: 0, HS: 3, HSem: 48 },
          { disciplina: "Pedagogia Comparada", T: 0, TP: 3, P: 0, HS: 3, HSem: 48 },
          { disciplina: "Seminário de Gestão e Inspecção", T: 2, TP: 0, P: 0, HS: 2, HSem: 32 },
          { disciplina: "Fundamentos da Educação Especial", T: 2, TP: 0, P: 0, HS: 2, HSem: 32 },
          { disciplina: "Monografia II", T: 3, TP: 0, P: 3, HS: 6, HSem: 96 },
          { disciplina: "Estágio Supervisionado", T: 3, TP: 0, P: 3, HS: 6, HSem: 96 },
        ]
      }
    },
    requisitos: '12ª Ano concluída',
    linkInscricao: 'https://portalonline.icsgisabelinha.com/Publico/Candidaturas/Candidatura'
  },
  {
    id: 4,
    title: 'Licenciatura em Sociologia',
    duration: '4 anos',
    description: 'Explore a Sociologia: compreenda as dinâmicas sociais, culturais e económicas que moldam o mundo contemporâneo',
    detalhes: 'Estude teorias sociológicas, métodos de pesquisa e análise social. Envolva-se em projetos comunitários e estágios práticos.',
    path: '/programas/licenciatura/detalhes-cursos/4',
    images: [
      require('../../assets/ANU_02.jpg'),
      require('../../assets/ANU_02.jpg'),
    ],
    objetivos: [
      'Formar sociólogos com uma sólida base teórica e prática.',
      'Desenvolver competências em pesquisa e análise social.',
      'Promover a compreensão das dinâmicas sociais e culturais.'
    ],
    planoCurricularCompleto: {
      "1º Ano": {
        "1º Semestre (16 semanas)": [
          { disciplina: "História do Pensamento Sociológico Clássico", T: 1, TP: 2, P: 0, HS: 3, HSem: 48 },
          { disciplina: "Metodologia de Investigação Científica", T: 2, TP: 0, P: 0, HS: 3, HSem: 32 },
          { disciplina: "Informática", T: 1, TP: 1, P: 0, HS: 3, HSem: 32 },
          { disciplina: "Língua Portuguesa I", T: 1, TP: 2, P: 0, HS: 2, HSem: 48 },
          { disciplina: "Língua de Opção I", T: 1, TP: 0, P: 0, HS: 2, HSem: 16 },
          { disciplina: "Introdução às Ciências Sociais", T: 2, TP: 0, P: 0, HS: 3, HSem: 32 },
          { disciplina: "Introdução à Sociologia", T: 2, TP: 0, P: 0, HS: 3, HSem: 32 },
          { disciplina: "Estatística I", T: 2, TP: 0, P: 0, HS: 3, HSem: 32 },
          { disciplina: "Psicologia Geral", T: 1, TP: 2, P: 0, HS: 3, HSem: 48 },
          { disciplina: "Sociologia Geral", T: 1, TP: 0, P: 0, HS: 3, HSem: 16 }
        ],
        "2º Semestre (16 semanas)": [
          { disciplina: "História do Pensamento Sociológico Clássico", T: 1, TP: 2, P: 0, HS: 3, HSem: 48 },
          { disciplina: "Metodologia de Investigação Científica", T: 2, TP: 1, P: 0, HS: 3, HSem: 48 },
          { disciplina: "Informática", T: 1, TP: 2, P: 0, HS: 3, HSem: 48 },
          { disciplina: "Língua Portuguesa I", T: 1, TP: 0, P: 0, HS: 2, HSem: 16 },
          { disciplina: "Língua de Opção I", T: 1, TP: 0, P: 0, HS: 2, HSem: 16 },
          { disciplina: "Int. às Ciências Sociais", T: 2, TP: 0, P: 0, HS: 3, HSem: 32 },
          { disciplina: "Introdução à Sociologia", T: 2, TP: 0, P: 0, HS: 3, HSem: 32 },
          { disciplina: "Estatística II", T: 1, TP: 0, P: 0, HS: 3, HSem: 16 },
          { disciplina: "Psicologia do Desenvolvimento Aprendizagem", T: 1, TP: 2, P: 0, HS: 3, HSem: 48 },
          { disciplina: "Filosofia Geral", T: 2, TP: 1, P: 0, HS: 3, HSem: 48 },
        ]
      },
      "2º Ano": {
        "3º Semestre (16 semanas)": [
          { disciplina: "História do Pensamento Sociológico Contemporâneo", T: 1, TP: 2, P: 0, HS: 3, HSem: 48 },
          { disciplina: "Metodologia de Investigação Científica", T: 1, TP: 2, P: 0, HS: 3, HSem: 48 },
          { disciplina: "Demografia", T: 2, TP: 1, P: 0, HS: 2, HSem: 48 },
          { disciplina: "História de Angola", T: 2, TP: 1, P: 0, HS: 3, HSem: 48 },
          { disciplina: "Língua Portuguesa II", T: 1, TP: 1, P: 0, HS: 2, HSem: 32 },
          { disciplina: "Língua de Opção II", T: 1, TP: 1, P: 0, HS: 2, HSem: 32 },
          { disciplina: "Sociologia da Educação", T: 1, TP: 2, P: 0, HS: 3, HSem: 48 },
          { disciplina: "Sociologia Geral II", T: 2, TP: 1, P: 0, HS: 3, HSem: 48 },
          { disciplina: "Psicologia Social", T: 1, TP: 2, P: 0, HS: 3, HSem: 48 },
          { disciplina: "Filosofia da Educação", T: 2, TP: 1, P: 0, HS: 3, HSem: 48 },
          { disciplina: "Didáctica Geral", T: 1, TP: 2, P: 0,  HS: 3, HSem: 48 },
        ],
        "4º Semestre (16 semanas)": [
          { disciplina: "História do Pensamento Sociológico Contemporâneo", T: 1, TP: 2, P: 0, HS: 3, HSem: 48 },
          { disciplina: "Metodologia de Investigação Científica", T: 1, TP: 2, P: 0, HS: 3, HSem: 48 },
          { disciplina: "Demografia", T: 2, TP: 1, P: 0, HS: 2, HSem: 48 },
          { disciplina: "História de Angola", T: 2, TP: 1, P: 0, HS: 3, HSem: 48 },
          { disciplina: "Língua Portuguesa II", T: 1, TP: 1, P: 0, HS: 2, HSem: 32 },
          { disciplina: "Língua de Opção II", T: 1, TP: 1, P: 0, HS: 2, HSem: 32 },
          { disciplina: "Sociologia da Educação", T: 1, TP: 2, P: 0,  HS: 3, HSem: 48 },
          { disciplina: "Sociologia Geral III", T: 2, TP: 1, P: 0,  HS: 3, HSem: 48 },
          { disciplina: "Psicologia Pedagógica", T: 1, TP: 2, P: 0,  HS: 3, HSem: 48 },
          { disciplina: "Antropologia Social e Cultural", T: 2, TP: 1, P: 0,  HS: 3, HSem: 48 },
        ]
      },
      "3º Ano": {
        "5º Semestre (16 semanas)": [
          { disciplina: "Prática Pedagógica I", T: 1, TP: 0, P: 4, HS: 5, HSem: 80 },
          { disciplina: "Didáctica da Sociologia", T: 1, TP: 2, P: 0, HS: 3, HSem: 48 },
          { disciplina: "Seminário Especializado", T: 1, TP: 2, P: 0, HS: 3, HSem: 48 },
          { disciplina: "História do Pensamento Sociológico Angolano", T: 2, TP: 1, P: 0, HS: 3, HSem: 48 },
          { disciplina: "Estratificação Social e Classes Sociais", T: 1, TP: 2, P: 0, HS: 3, HSem: 48 },
          { disciplina: "Sociologia Rural", T: 2, TP: 1, P: 0, HS: 3, HSem: 48 },
          { disciplina: "Sociologia da Medicina", T: 1, TP: 2, P: 0, HS: 3, HSem: 48 },
          { disciplina: "Organização e Gestão e Inspecção", T: 2, TP: 1, P: 0, HS: 3, HSem: 48 },
          { disciplina: "Desenvolvimento Curricular", T: 1, TP: 2, P: 0, HS: 3, HSem: 48 },
        ],
        "6º Semestre (16 semanas)": [
          { disciplina: "Prática Pedagógica I", T: 1, TP: 0, P: 4, HS: 5, HSem: 80 },
          { disciplina: "Didáctica da Sociologia", T: 1, TP: 2, P: 0, HS: 3, HSem: 48 },
          { disciplina: "Seminário Especializado", T: 1, TP: 2, P: 0, HS: 3, HSem: 48 },
          { disciplina: "Sociologia Africana", T: 2, TP: 1, P: 0, HS: 3, HSem: 48 },
          { disciplina: "Sociologia da Família", T: 1, TP: 2, P: 0, HS: 3, HSem: 48 },
          { disciplina: "Sociologia do Trabalho", T: 2, TP: 1, P: 0, HS: 3, HSem: 48 },
          { disciplina: "Sociologia Urbana", T: 1, TP: 2, P: 0, HS: 3, HSem: 48 },
          { disciplina: "Problemas Sociais de Angola", T: 2, TP: 1, P: 0, HS: 3, HSem: 48 },
          { disciplina: "Etnossociologia", T: 1, TP: 2, P: 0, HS: 3, HSem: 48 }
        ]
      },
      "4º Ano": {
        "7º Semestre (16 semanas)": [
          { disciplina: "Prática Pedagógica II", T: 1, TP: 0, P: 4, HS: 3, HSem: 80 },
          { disciplina: "Sociologia Política", T: 1, TP: 2, P: 0, HS: 3, HSem: 48 },
          { disciplina: "Políticas de Educação", T:2, TP: 1, P: 0, HS: 3, HSem: 48 },
          { disciplina: "Culturas Africanas", T: 1, TP: 2, P: 0, HS: 3, HSem: 48 },
          { disciplina: "Metodologia de Investigação em Educação", T: 2, TP: 1, P: 0, HS: 3, HSem: 48 },
          { disciplina: "Sociologia do Consumo", T: 1, TP: 2, P: 0, HS: 3, HSem: 48 },
          { disciplina: "Sociologia da Cultura e da Ciência", T: 2, TP: 1, P: 0, HS: 3, HSem: 48 },
          { disciplina: "Sociologia do Desenvolvimento", T: 1, TP: 2, P: 0, HS: 3, HSem: 48 },
          
        ],
        "8º Semestre (16 semanas)": [
          { disciplina: "Prática Pedagógica II", T: 1, TP: 0, P: 4, HS: 5, HSem: 80 },
          { disciplina: "Sociologia da Religião", T: 1, TP: 2, P: 0, HS: 3, HSem: 48 },
          { disciplina: "Teoria Reprod. Social e Cultural", T: 2, TP: 2, P: 0, HS: 4, HSem: 64 },
          { disciplina: "Sociologia do Currículo", T: 2, TP: 2, P: 0, HS: 4, HSem: 64 },
          { disciplina: "Trabalho de Fim de Curso", T: 2, TP: 4, P: 0, HS: 6, HSem: 96 }
        ]
      }
    },
    requisitos: '12ª Ano concluída',
    linkInscricao: 'https://portalonline.icsgisabelinha.com/Publico/Candidaturas/Candidatura'
  },
  {
    id: 5,
    title: 'Licenciatura em Direito',
    duration: '5 anos',
    description: 'Explore o Direito: compreenda as dinâmicas sociais, culturais e económicas que moldam o mundo contemporâneo',
    detalhes: 'Estude teorias sociológicas, métodos de pesquisa e análise social. Envolva-se em projetos comunitários e estágios práticos.',
    path: '/programas/licenciatura/detalhes-cursos/5',
    images: [
      require('../../assets/ANU_02.jpg'),
      require('../../assets/ANU_02.jpg'),
    ],
    objetivos: [
      'Formar juristas com uma sólida base teórica e prática.',
      'Desenvolver competências em pesquisa e análise jurídica.',
      'Promover a compreensão das dinâmicas sociais e culturais.'
    ],
    planoCurricularCompleto: {
      "1º Ano": {
        "1º Semestre (16 semanas)": [
          { disciplina: "Língua Portuguesa", T: 2, TP: 0, P: 2, HS: 4, HSem: 64 },
          { disciplina: "Introdução ao Estudo do Direito", T: 2, TP: 0, P: 2, HS: 4, HSem: 64 },
          { disciplina: "Latim", T: 2, TP: 0, P: 2, HS: 4, HSem: 64 },
          { disciplina: "Economia Política", T: 2, TP: 2, P: 0, HS: 4, HSem: 64 },
          { disciplina: "Metodologia de Investigação  Científica", T: 2, TP: 2, P: 0, HS: 4, HSem: 64 },
          { disciplina: "História do Pensamento Jurídico", T: 2, TP: 2, P: 0, HS: 4, HSem: 64 },
          { disciplina: "Direito Contitucional e Ciência Política", T: 2, TP: 2, P: 0, HS: 4, HSem: 64 },
        ],
        "2º Semestre (16 semanas)": [
          { disciplina: "Língua Portuguesa", T: 2, TP: 0, P: 2, HS: 4, HSem: 64 },
          { disciplina: "Introdução ao Estudo do Direito", T: 2, TP: 0, P: 2, HS: 4, HSem: 64 },
          { disciplina: "Economia Política", T: 2, TP: 0, P: 2, HS: 4, HSem: 64 },
          { disciplina: "Metodologia de Investigação Científica", T: 2, TP: 2, P: 0, HS: 4, HSem: 64 },
          { disciplina: "História do Pensamento Jurídico", T: 2, TP: 2, P: 0, HS: 4, HSem: 64 },
          { disciplina: "Direito Contitucional e Ciência Política", T: 2, TP: 2, P: 0, HS: 4, HSem: 64 },
          { disciplina: "Sociologia Jurídica", T: 2, TP: 2, P: 0, HS: 4, HSem: 64 },
        ]
      },
      "2º Ano": {
        "3º Semestre (16 semanas)": [
          { disciplina: "Direito Administrativo", T: 2, TP: 0, P: 2, HS: 4, HSem: 64 },
          { disciplina: "Direito Internacional Público", T: 2, TP: 0, P: 2, HS: 4, HSem: 64 },
          { disciplina: "Teoria Geral do Direito Civil", T: 2, TP: 2, P: 2, HS: 6, HSem: 96 },
          { disciplina: "Direito Fundamental", T: 2, TP: 0, P: 2, HS: 4, HSem: 64 },
          { disciplina: "Direito Económico", T: 2, TP: 2, P: 2, HS: 6, HSem: 96 },
        ],
        "4º Semestre (16 semanas)": [
          { disciplina: "Direito Administrativo", T: 2, TP: 0, P: 2, HS: 4, HSem: 64 },
          { disciplina: "Direito Internacional Público", T: 2, TP: 0, P: 2, HS: 4, HSem: 64 },
          { disciplina: "Teoria Geral do Direito Civil", T: 2, TP: 2, P: 2, HS: 6, HSem: 96 },
          { disciplina: "Direito da Integração Regional", T: 2, TP: 0, P: 2, HS: 4, HSem: 64 },
          { disciplina: "Finanças Públicas", T: 2, TP: 2, P: 2, HS: 4, HSem: 96 },
        ]
      },
      "3º Ano": {
        "5º Semestre (16 semanas)": [
          { disciplina: "Direito do Umbanismo e Ambiente", T: 2, TP: 0, P: 2, HS: 4, HSem: 64 },
          { disciplina: "Direito das Obrigações", T: 2, TP: 0, P: 2, HS: 4, HSem: 64 },
          { disciplina: "Direito Penal", T: 2, TP: 2, P: 2, HS: 6, HSem: 96 },
          { disciplina: "Direito do Trabalho e Segurança Social", T: 2, TP: 0, P: 2, HS: 4, HSem: 64 },
          { disciplina: "Diireito Processual  Civil I (Declarativo)", T: 2, TP: 2, P: 2, HS: 4, HSem: 96 },
        ],
        "6º Semestre (16 semanas)": [
          { disciplina: "Direito das Obrigações", T: 2, TP: 0, P: 2, HS: 4, HSem: 64 },
          { disciplina: "Direito Penal I", T: 2, TP: 2, P: 2, HS: 6, HSem: 96 },
          { disciplina: "Direito do Trabalho e Segurança Social", T: 2, TP: 2, P: 2, HS: 6, HSem: 96 },
          { disciplina: "Diireito Processual  Civil I (Declarativo)", T: 2, TP: 0, P: 2, HS: 4, HSem: 64 },
          { disciplina: "Direito Fiscal", T: 2, TP: 2, P: 2, HS: 6, HSem: 96 }
        ]
      },
      "4º Ano": {
        "7º Semestre (16 semanas)": [
          { disciplina: "Direito Comercial", T: 2, TP: 0, P: 4, HS: 6, HSem: 96 },
          { disciplina: "Direito Processual Penal", T: 2, TP: 2, P: 2, HS: 6, HSem: 96},
          { disciplina: "Direito da Família e das Sucessões", T:2, TP: 2, P: 2, HS: 6, HSem: 96},
          { disciplina: "Contrato Especial", T: 2, TP: 0, P: 4, HS: 6, HSem: 96 }
        ],
        "8º Semestre (16 semanas)": [
          { disciplina: "Direito Reais", T: 2, TP: 0, P: 2, HS: 4, HSem: 64 },
          { disciplina: "Contencioso Administrativo", T: 3, TP: 0, P: 3, HS: 6, HSem: 96 },
          { disciplina: "Ética e Deontologia", T: 2, TP: 0, P: 2, HS: 4, HSem: 64 },
          { disciplina: "Opção IV- Direito Processual Civil II (Processo Excecutivo)", T: 3, TP: 0, P: 3, HS: 6, HSem: 96 },
        ]
      },
      "5º Ano": {
        "9º Semestre (16 semanas)": [
          { disciplina: "Direito Internacional Privado", T: 3, TP: 0, P: 3, HS: 6, HSem: 96 },
          { disciplina: "Direito Penal II", T: 2, TP: 2, P: 2, HS: 6, HSem: 96},
          { disciplina: "Medicina Legal", T:2, TP: 0, P: 2, HS: 4, HSem: 64},
          { disciplina: "Filosofia Do Direito", T: 2, TP: 0, P: 2, HS: 4, HSem: 64 }
        ],
        "10º Semestre (16 semanas)": [
          { disciplina: "Opção I-Direito Processual Penal II", T: 3, TP: 0, P: 3, HS: 6, HSem: 96 },
          { disciplina: "Opção II-Direito Comparado", T: 3, TP: 0, P: 3, HS: 6, HSem: 96 },
          { disciplina: "Opção III- Direito Processual Civil III (Recurso)", T: 3, TP: 0, P: 3, HS: 6, HSem: 96 },
        ]
      }
    },
    requisitos: '12ª Ano concluída',
    linkInscricao: 'https://portalonline.icsgisabelinha.com/Publico/Candidaturas/Candidatura'
  },
  {
    id: 6,
    title: 'Licenciatura em Gestão de Empresas',
    duration: '4 anos',
    description: 'Explore a Gestão de Empresas: compreenda as dinâmicas sociais, culturais e económicas que moldam o mundo contemporâneo',
    detalhes: 'Estude teorias sociológicas, métodos de pesquisa e análise social. Envolva-se em projetos comunitários e estágios práticos.',
    path: '/programas/licenciatura/detalhes-cursos/6',
    images: [
      require('../../assets/ANU_02.jpg'),
      require('../../assets/ANU_02.jpg'),
    ],
    objetivos: [
      'Formar gestores com uma sólida base teórica e prática.',
      'Desenvolver competências em pesquisa e análise de gestão.',
      'Promover a compreensão das dinâmicas sociais e culturais.'
    ],
    planoCurricularCompleto: {
      "1º Ano": {
        "1º Semestre (16 semanas)": [
          { disciplina: "Inglês I", T: 2, TP: 2, P: 0, HS: 64, HSem: 4 },
          { disciplina: "Informática", T: 2, TP: 2, P: 0, HS: 64, HSem: 4 },
          { disciplina: "Língua Portuguesa I", T: 2, TP: 2, P: 0, HS: 64, HSem: 4 },
          { disciplina: "Metodologia da Investigação Científica", T: 2, TP: 2, P: 0, HS: 96, HSem: 6 },
          { disciplina: "Matemática Geral", T: 2, TP: 2, P: 2, HS: 96, HSem: 6 },
          { disciplina: "Teoria Geral da Administração I", T: 2, TP: 2, P: 2, HS: 96, HSem: 6 },
        ],
        "2º Semestre (16 semanas)": [
          { disciplina: "Fundamentos do Pensamento Contemporâneo", T: 2, TP: 2, P: 0, HS: 64, HSem: 4 },
          { disciplina: "Ética e Deontologia Profissional", T: 2, TP: 2, P: 0, HS: 64, HSem: 4 },
          { disciplina: "Língua Portuguesa II", T: 2, TP: 2, P: 0, HS: 64, HSem: 4 },
          { disciplina: "Teoria Geral da Administração II", T: 2, TP: 2, P: 2, HS: 96, HSem: 6 },
          { disciplina: "Noções Gerais de Empreendedorismo", T: 2, TP: 2, P: 0, HS: 64, HSem: 4 },
          { disciplina: "Metodologia da Investigação Científica", T: 2, TP: 2, P: 0, HS: 64, HSem: 4 },
          { disciplina: "Inglês II", T: 2, TP: 2, P: 0, HS: 64, HSem: 4 },
        ]
      },
      "2º Ano": {
        "3º Semestre (16 semanas)": [
          { disciplina: "Fundamentos da Economia", T: 2, TP: 2, P: 2, HS: 96, HSem: 6 },
          { disciplina: "Contabilidade Para Administrador", T: 2, TP: 2, P: 2, HS: 96, HSem: 6 },
          { disciplina: "Sociologia das Organizações", T: 2, TP: 0, P: 2, HS: 64, HSem: 4 },
          { disciplina: "História Geral e Económica de Angola", T: 2, TP: 0, P: 2, HS: 64, HSem: 4 },
          { disciplina: "Estatística Geral", T: 2, TP: 2, P: 2, HS: 96, HSem: 4 },
          { disciplina: "Direito Público/Privado", T: 2, TP: 0, P: 2, HS: 64, HSem: 4 },
        ],
        "4º Semestre (16 semanas)": [
          { disciplina: "Psicologia das Organizações", T: 2, TP: 0, P: 2, HS: 64, HSem: 4 },
          { disciplina: "Comunicação Institucional", T: 2, TP: 0, P: 2, HS: 64, HSem: 4 },
          { disciplina: "Direito Administrativo", T: 2, TP: 0, P: 2, HS: 64, HSem: 4 },
          { disciplina: "Direito Empresarial", T: 2, TP: 0, P: 2, HS: 64, HSem: 4 },
          { disciplina: "Gestão de Qualidade e Inovação", T: 2, TP: 2, P: 2, HS: 96, HSem: 6 },
          { disciplina: "Instituições e Política da União Africana", T: 2, TP: 2, P: 2, HS: 96, HSem: 6 },
        ]
      },
      "3º Ano": {
        "5º Semestre (16 semanas)": [
          { disciplina: "Gestão Orçamental e Financeira", T: 2, TP: 2, P: 2, HS: 96, HSem: 6 },
          { disciplina: "Contabilidade Financeira Avançada", T: 2, TP: 2, P: 2, HS: 96, HSem: 6 },
          { disciplina: "Problemas SócioEconómicos de Angola", T: 2, TP: 0, P: 2, HS: 64, HSem: 4 },
          { disciplina: "Gestão de Pessoas", T: 2, TP: 0, P: 2, HS: 64, HSem: 4 },
          { disciplina: "Economia e Finanças", T: 2, TP: 2, P: 2, HS: 96, HSem: 6 },
          { disciplina: "Informática de Gestão", T: 2, TP: 0, P: 2, HS: 64, HSem: 4 },
        ],
        "6º Semestre (16 semanas)": [
          { disciplina: "Direito do Trabalho", T: 3, TP: 3, P: 3, HS: 96, HSem: 6 },
          { disciplina: "Comportamento Organizacional", T: 2, TP: 2, P: 2, HS: 96, HSem: 6 },
          { disciplina: "Sistemas de Informação da Empresa", T: 2, TP: 2, P: 2, HS: 96, HSem: 6 },
          { disciplina: "Optativa I - Gestão dos Recursos Humanos", T: 2, TP: 2, P: 2, HS: 96, HSem: 6 },
        ]
      },
      "4º Ano": {
        "7º Semestre (16 semanas)": [
          { disciplina: "Administração Pública Angolana", T: 2, TP: 0, P: 2, HS: 96, HSem: 6 },
          { disciplina: "Estratégia Empresarial", T: 2, TP: 2, P: 2, HS: 96, HSem: 6},
          { disciplina: "Economia Internacional", T:2, TP: 2, P: 2, HS: 64, HSem: 4},
          { disciplina: "Formação de Preços", T: 2, TP: 0, P: 2, HS: 64, HSem: 4 },
          { disciplina: "Análise Financeira", T: 2, TP: 0, P: 2, HS: 64, HSem: 4 },
          { disciplina: "Optativa II - Marketing", T: 2, TP: 0, P: 2, HS: 64, HSem: 4 },
          { disciplina: "Monografia I (TFC)", T: 1, TP: 0, P: 1, HS: 32, HSem: 2 }
        ],
        "8º Semestre (16 semanas)": [
          { disciplina: "Relações Internacionais", T: 2, TP: 2, P: 2, HS: 96, HSem: 4 },
          { disciplina: "Ética e Resposnabilidade Social", T: 2, TP: 0, P: 2, HS: 64, HSem: 4 },
          { disciplina: "Auditoria Fiscal e Tributária", T: 2, TP: 2, P: 2, HS: 96, HSem: 4 },
          { disciplina: "Análise e Gestão de Projecto de Investimento", T: 2, TP: 0, P: 2, HS: 64, HSem: 4 },
          { disciplina: "Gestão do Projecto", T: 2, TP: 0, P: 2, HS: 64, HSem: 4 },
          { disciplina: "Monografia II (TFC)", T: 1, TP: 0, P: 1, HS: 32, HSem: 2 },
          { disciplina: "Optativa III - Organização e Gestão de Empresa", T: 2, TP: 0, P: 2, HS: 64, HSem: 4 },
        ]
      }
    },
    requisitos: '12ª Ano concluída',
    linkInscricao: 'https://portalonline.icsgisabelinha.com/Publico/Candidaturas/Candidatura'
  },
  {
    id: 7,
    title: 'Licenciatura em Enfermagem',
    duration: '4 anos',
    description: 'Explore a Enfermagem: compreenda as dinâmicas sociais, culturais e económicas que moldam o mundo contemporâneo',
    detalhes: 'Estude teorias sociológicas, métodos de pesquisa e análise social. Envolva-se em projetos comunitários e estágios práticos.',
    path: '/programas/licenciatura/detalhes-cursos/7',
    images: [
      require('../../assets/ANU_02.jpg'),
      require('../../assets/ANU_02.jpg'),
    ],
    objetivos: [
      'Formar enfermeiros com uma sólida base teórica e prática.',
      'Desenvolver competências em pesquisa e análise de enfermagem.',
      'Promover a compreensão das dinâmicas sociais e culturais.'
    ],
    planoCurricularCompleto: {
      "1º Ano": {
      "1º Semestre (16 semanas)": [
        { "disciplina": "Língua Portuguesa", T: 2, TP: 2, P: 0, HS: 4, HSem: 64 },
        { "disciplina": "Contabilidade Geral I", T: 2, TP: 2, P: 2, HS: 6, HSem: 96 },
        { "disciplina": "Metodologia de Investigação Científica", T: 2, TP: 2, P: 2, HS: 6, HSem: 96 },
        { "disciplina": "Matemática I", T: 2, TP: 2, P: 2, HS: 6, HSem: 96 },
        { "disciplina": "Sociologia Geral", T: 2, TP: 2, P: 0, HS: 4, HSem: 64 }
      ],
      "2º Semestre (16 semanas)": [
        { "disciplina": "Informática", T: 2, TP: 2, P: 0, HS: 4, HSem: 64 },
        { "disciplina": "Direito", T: 2, TP: 2, P: 0, HS: 4, HSem: 64 },
        { "disciplina": "Matemática II", T: 2, TP: 2, P: 2, HS: 6, HSem: 96 },
        { "disciplina": "Contabilidade Geral II", T: 2, TP: 2, P: 2, HS: 6, HSem: 96 },
        { "disciplina": "Psicologia das Organizações", T: 2, TP: 2, P: 0, HS: 4, HSem: 64 }
      ]
    },
    "2º Ano": {
      "3º Semestre (16 semanas)": [
        { "disciplina": "Inglês", T: 2, TP: 2, P: 0, HS: 4, HSem: 64 },
        { "disciplina": "Contabilidade Analítica I", T: 2, TP: 2, P: 2, HS: 6, HSem: 96 },
        { "disciplina": "Direito Comercial", T: 2, TP: 2, P: 0, HS: 4, HSem: 64 },
        { "disciplina": "Álgebra Linear", T: 2, TP: 2, P: 2, HS: 6, HSem: 96 },
        { "disciplina": "Estatística I", T: 2, TP: 2, P: 2, HS: 6, HSem: 96 }
      ],
      "4º Semestre (16 semanas)": [
        { "disciplina": "Cálculo Financeiro", T: 2, TP: 2, P: 2, HS: 6, HSem: 96 },
        { "disciplina": "Investigação Operacional", T: 2, TP: 2, P: 2, HS: 6, HSem: 96 },
        { "disciplina": "Contabilidade Analítica II", T: 2, TP: 2, P: 2, HS: 6, HSem: 96 },
        { "disciplina": "Estatística II", T: 2, TP: 2, P: 2, HS: 6, HSem: 96 },
        { "disciplina": "Seminário de Contabilidade e Auditoria", T: 2, TP: 2, P: 0, HS: 4, HSem: 64 },
        { "disciplina": "Microeconomia", T: 2, TP: 2, P: 0, HS: 4, HSem: 64 }
      ]
    },
    "3º Ano": {
      "5º Semestre (16 semanas)": [
        { "disciplina": "Macroeconomia", T: 2, TP: 2, P: 0, HS: 4, HSem: 64 },
        { "disciplina": "Direito Económico", T: 2, TP: 2, P: 0, HS: 4, HSem: 64 },
        { "disciplina": "Fiscalidade I", T: 2, TP: 2, P: 0, HS: 4, HSem: 64 },
        { "disciplina": "Gestão Financeira I", T: 2, TP: 2, P: 0, HS: 4, HSem: 64 },
        { "disciplina": "Organização e Gestão de Empresas", T: 2, TP: 2, P: 0, HS: 4, HSem: 64 },
        { "disciplina": "Contabilidade das Sociedades", T: 2, TP: 2, P: 0, HS: 4, HSem: 64 },
        { "disciplina": "Contabilidade Pública", T: 2, TP: 2, P: 0, HS: 4, HSem: 64 }
      ],
      "6º Semestre (16 semanas)": [
        { "disciplina": "Auditoria de Gestão", T: 2, TP: 2, P: 0, HS: 4, HSem: 64 },
        { "disciplina": "Econometria", T: 2, TP: 2, P: 0, HS: 4, HSem: 64 },
        { "disciplina": "Fiscalidade II", T: 2, TP: 2, P: 0, HS: 4, HSem: 64 },
        { "disciplina": "Gestão Financeira II", T: 2, TP: 2, P: 0, HS: 4, HSem: 64 },
        { "disciplina": "Gestão Orçamental", T: 2, TP: 2, P: 0, HS: 4, HSem: 64 },
        { "disciplina": "Sociologia do Trabalho e Emprego", T: 2, TP: 2, P: 0, HS: 4, HSem: 64 }
      ]
    },
    "4º Ano": {
      "7º Semestre (16 semanas)": [
        { "disciplina": "Informática de Gestão", T: 2, TP: 2, P: 2, HS: 6, HSem: 96 },
        { "disciplina": "Auditoria e Revisão de Contas I", T: 2, TP: 2, P: 2, HS: 6, HSem: 96 },
        { "disciplina": "Contabilidade Financeira Avançada", T: 2, TP: 2, P: 2, HS: 6, HSem: 96 },
        { "disciplina": "Análise de Investimento I", T: 2, TP: 2, P: 0, HS: 4, HSem: 64 },
        { "disciplina": "Contabilidade de Seguros", T: 2, TP: 2, P: 0, HS: 4, HSem: 64 }
      ],
      "8º Semestre (16 semanas)": [
        { "disciplina": "Direito e Legislação do Trabalho", "T": 2, "TP": 2, "P": 0, "HS": 4, "HSem": 64 },
        { "disciplina": "Análise Financeira", "T": 2, "TP": 2, "P": 0, "HS": 4, "HSem": 64 },
        { "disciplina": "Auditoria e Revisão de Contas II", "T": 2, "TP": 2, "P": 0, "HS": 4, "HSem": 64 },
        { "disciplina": "Auditoria Tributária", "T": 2, "TP": 2, "P": 0, "HS": 4, "HSem": 64 },
        { "disciplina": "Análise de Investimento II", "T": 2, "TP": 2, "P": 0, "HS": 4, "HSem": 64 },
        { "disciplina": "Monografia", "T": 2, "TP": 2, "P": 0, "HS": 4, "HSem": 64 },
        { "disciplina": "Estágio Supervisionado", "T": 2, "TP": 2, "P": 0, "HS": 4, "HSem": 64 }
      ]
    }
    },
    requisitos: '12ª Ano concluída',
    linkInscricao: 'https://portalonline.icsgisabelinha.com/Publico/Candidaturas/Candidatura'
  },
  {
    id: 8,
    title: 'Licenciatura em Contabilidade',
    duration: '4 anos',
    description: 'Explore a Contabilidade: compreenda as dinâmicas sociais, culturais e económicas que moldam o mundo contemporâneo',
    detalhes: 'Estude teorias sociológicas, métodos de pesquisa e análise social. Envolva-se em projetos comunitários e estágios práticos.',
    path: '/programas/licenciatura/detalhes-cursos/8',
    images: [
      require('../../assets/ANU_02.jpg'),
      require('../../assets/ANU_02.jpg'),
    ],
    objetivos: [
      'Formar contadores com uma sólida base teórica e prática.',
      'Desenvolver competências em pesquisa e análise contábil.',
      'Promover a compreensão das dinâmicas sociais e culturais.'
    ],
    planoCurricularCompleto: {

      "1º Ano": {
      "1º Semestre (16 semanas)": [
        { "disciplina": "Língua Portuguesa", T: 2, TP: 2, P: 0, HS: 4, HSem: 64 },
        { "disciplina": "Contabilidade Geral I", T: 2, TP: 2, P: 2, HS: 6, HSem: 96 },
        { "disciplina": "Metodologia de Investigação Científica", T: 2, TP: 2, P: 2, HS: 6, HSem: 96 },
        { "disciplina": "Matemática I", T: 2, TP: 2, P: 2, HS: 6, HSem: 96 },
        { "disciplina": "Sociologia Geral", T: 2, TP: 0, P: 2, HS: 4, HSem: 64 }
      ],
      "2º Semestre (16 semanas)": [
        { "disciplina": "Informática", T: 2, TP: 0, P: 2, HS: 4, HSem: 64 },
        { "disciplina": "Direito", T: 2, TP: 0, P: 2, HS: 4, HSem: 64 },
        { "disciplina": "Metodologia de Investigação Científica", T: 2, TP: 2, P: 2, HS: 6, HSem: 96 },
        { "disciplina": "Matemática II", T: 2, TP: 2, P: 2, HS: 6, HSem: 96 },
        { "disciplina": "Contabilidade Geral II", T: 2, TP: 2, P: 2, HS: 6, HSem: 96 },
        { "disciplina": "Psicologia das Organizações", T: 2, TP: 2, P: 2, HS: 6, HSem: 96 }
      ]
    },
    "2º Ano": {
      "3º Semestre (16 semanas)": [
        { "disciplina": "Inglês", T: 2, TP: 0, P: 2, HS: 4, HSem: 64 },
        { "disciplina": "Contabilidade Analítica I", T: 0 , TP: 2, P: 2, HS: 6, HSem: 96 },
        { "disciplina": "Direito Comercial", T: 2, TP: 0, P: 2, HS: 4, HSem: 64 },
        { "disciplina": "Álgebra Linear", T: 2, TP: 0, P: 2, HS: 6, HSem: 96 },
        { "disciplina": "Estatística I", T: 2, TP: 0, P: 2, HS: 6, HSem: 96 }
      ],
      "4º Semestre (16 semanas)": [
        { "disciplina": "Cálculo Financeiro", T: 2, TP: 2, P: 2, HS: 6, HSem: 96 },
        { "disciplina": "Investigação Operacional", T: 2, TP: 0, P: 2, HS: 4, HSem: 64 },
        { "disciplina": "Contabilidade Analítica II", T: 2, TP: 2, P: 2, HS: 6, HSem: 96 },
        { "disciplina": "Estatística II", T: 2, TP: 0, P: 2, HS: 4, HSem: 64 },
        { "disciplina": "Seminário de Contabilidade e Auditoria", T: 2, TP: 0, P: 2, HS: 4, HSem: 64 },
        { "disciplina": "Microeconomia", T: 2, TP: 0, P: 2, HS: 4, HSem: 64 }
      ]
    },
    "3º Ano": {
      "5º Semestre (16 semanas)": [
        { "disciplina": "Macroeconomia", T: 2, TP: 0, P: 2, HS: 4, HSem: 64 },
        { "disciplina": "Direito Económico", T: 2, TP: 0, P: 2, HS: 4, HSem: 64 },
        { "disciplina": "Fiscalidade I", T: 2, TP: 2, P: 2, HS: 4, HSem: 64 },
        { "disciplina": "Gestão Financeira I", T: 2, TP: 0, P: 2, HS: 4, HSem: 64 },
        { "disciplina": "Organização e Gestão de Empresas", T: 2, TP: 0, P: 2, HS: 4, HSem: 64 },
        { "disciplina": "Contabilidade das Sociedades", T: 2, TP: 0, P: 2, HS: 4, HSem: 64 },
        { "disciplina": "Contabilidade Pública", T: 2, TP: 0, P: 2, HS: 4, HSem: 64 }
      ],
      "6º Semestre (16 semanas)": [
        { "disciplina": "Auditoria de Gestão", T: 2, TP: 0, P: 4, HS: 6, HSem: 96 },
        { "disciplina": "Econometria", T: 2, TP: 0, P: 4, HS: 6, HSem: 96 },
        { "disciplina": "Fiscalidade II", T: 0, TP: 2, P: 2, HS: 4, HSem: 64 },
        { "disciplina": "Gestão Financeira II", T: 2, TP: 0, P: 2, HS: 4, HSem: 64 },
        { "disciplina": "Gestão Orçamental", T: 2, TP: 0, P: 4, HS: 6, HSem: 96 },
        { "disciplina": "Sociologia do Trabalho e Emprego", T: 2, TP: 0, P: 2, HS: 4, HSem: 64 }
      ]
    },
    "4º Ano": {
      "7º Semestre (16 semanas)": [
        { "disciplina": "Informática de Gestão", T: 2, TP: 2, P: 2, HS: 6, HSem: 96 },
        { "disciplina": "Auditoria e Revisão de Contas I", T: 2, TP: 2, P: 2, HS: 6, HSem: 96 },
        { "disciplina": "Contabilidade Financeira Avançada", T: 2, TP: 2, P: 2, HS: 6, HSem: 96 },
        { "disciplina": "Análise de Investimento I", T: 2, TP: 2, P: 0, HS: 4, HSem: 64 },
        { "disciplina": "Contabilidade de Seguros", T: 2, TP: 2, P: 0, HS: 4, HSem: 64 }
      ],
      "8º Semestre (16 semanas)": [
        { "disciplina": "Direito e Legislação do Trabalho", T: 2, TP: 0, P: 2, HS: 4, HSem: 64 },
        { "disciplina": "Análise Financeira", T: 2, TP: 0, P: 2, HS: 4, HSem: 64 },
        { "disciplina": "Auditoria e Revisão de Contas II", T: 2, TP: 0, P: 2, HS: 4, HSem: 64 },
        { "disciplina": "Auditoria Tributária", T: 2, TP: 0, P: 2, HS: 4, HSem: 64 },
        { "disciplina": "Análise de Investimento II", T: 2, TP: 2, P: 2, HS: 4, HSem: 64 },
        { "disciplina": "Monografia", T: 2, TP: 0, P: 2, HS: 4, HSem: 64 },
        { "disciplina": "Estágio Supervisionado", T: 2, TP: 2, P: 2, HS: 6, HSem: 96 }
      ]
    },
},
    requisitos: '12ª Ano concluída',
    linkInscricao: 'https://portalonline.icsgisabelinha.com/Publico/Candidaturas/Candidatura'
  },
  {
  "id": 9,
  "title": "Licenciatura em Economia",
  "duration": "4 anos",
  "description": "Formação em Economia: domine os princípios económicos, análise de mercados e políticas económicas para uma carreira sólida no mundo empresarial e institucional",
  "detalhes": "Estudo aprofundado da microeconomia, macroeconomia, econometria, história económica e análise financeira. Desenvolva competências para análise económica e gestão de projetos.",
  "path": "/programas/licenciatura/detalhes-cursos/9",
  "images": [
    require('../../assets/ANU_02.jpg'),
    require('../../assets/ANU_02.jpg'),
  ],
  "objetivos": [
    'Formar economistas com sólida base teórica e prática',
    'Desenvolver competências em análise económica e econometria',
    'Preparar profissionais para políticas económicas e gestão financeira'
  ],
  "planoCurricularCompleto": {
    "1º Ano": {
      "1º Semestre (16 semanas)": [
        { "disciplina": "Introdução à Economia I", "T": 3, "TP": 0, "P": 3, "HS": 6, "HSem": 96 },
        { "disciplina": "Introdução a Informática", "T": 0, "TP": 2, "P": 0, "HS": 2, "HSem": 32 },
        { "disciplina": "Metodologia da Investigação Científica", "T": 2, "TP": 2, "P": 0, "HS": 4, "HSem": 64 },
        { "disciplina": "Língua Portuguesa I", "T": 2, "TP": 0, "P": 0, "HS": 4, "HSem": 64 },
        { "disciplina": "Cálculo I", "T": 3, "TP": 0, "P": 3, "HS": 6, "HSem": 96 },
        { "disciplina": "Inglês I", "T": 2, "TP": 0, "P": 0, "HS": 4, "HSem": 64 }
      ],
      "2º Semestre (16 semanas)": [
        { "disciplina": "Introdução a Economia II", "T": 3, "TP": 3, "P": 0, "HS": 6, "HSem": 96 },
        { "disciplina": "Ética Deontológica Profissional", "T": 0, "TP": 2, "P": 0, "HS": 2, "HSem": 32 },
        { "disciplina": "Língua Portuguesa II", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 },
        { "disciplina": "Cálculo II", "T": 3, "TP": 0, "P": 3, "HS": 6, "HSem": 96 },
        { "disciplina": "Inglês II", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 },
        { "disciplina": "História do Pensamento Económico I", "T": 2, "TP": 2, "P": 0, "HS": 4, "HSem": 48 },
        { "disciplina": "Metodologia da Investigação Científica", "T": 2, "TP": 2, "P": 0, "HS": 4, "HSem": 48 }
      ]
    },
    "2º Ano": {
      "3º Semestre (16 semanas)": [
        { "disciplina": "Introdução a Estatística", "T": 3, "TP": 0, "P": 3, "HS": 6, "HSem": 96 },
        { "disciplina": "Contabilidade Geral", "T": 3, "TP": 0, "P": 3, "HS": 6, "HSem": 96 },
        { "disciplina": "Análise Matemática I", "T": 2, "TP": 0, "P": 4, "HS": 6, "HSem": 96 },
        { "disciplina": "Informática de Gestão", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 },
        { "disciplina": "História do Pensamento Económico II", "T": 2, "TP": 2, "P": 0, "HS": 4, "HSem": 64 },
        { "disciplina": "Microeconomia I", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 }
      ],
      "4º Semestre (16 semanas)": [
        { "disciplina": "Métodos Quantitativos para Negócios", "T": 3, "TP": 0, "P": 3, "HS": 6, "HSem": 96 },
        { "disciplina": "Análises Matemática II", "T": 3, "TP": 0, "P": 3, "HS": 6, "HSem": 96 },
        { "disciplina": "Gestão de Projecto", "T": 2, "TP": 0, "P": 4, "HS": 6, "HSem": 96 },
        { "disciplina": "Fundamentos do Pensamento Contemporâneo", "T": 2, "TP": 2, "P": 0, "HS": 4, "HSem": 64 },
        { "disciplina": "Introdução a Econometria", "T": 2, "TP": 2, "P": 0, "HS": 4, "HSem": 64 },
        { "disciplina": "Microeconomia II", "T": 2, "TP": 2, "P": 2, "HS": 4, "HSem": 64 }
      ]
    },
    "3º Ano": {
      "5º Semestre (16 semanas)": [
        { "disciplina": "História Económica de Angola", "T": 2, "TP": 0, "P": 4, "HS": 6, "HSem": 96 },
        { "disciplina": "Análise Financeira", "T": 2, "TP": 0, "P": 4, "HS": 6, "HSem": 96 },
        { "disciplina": "Econometria", "T": 2, "TP": 0, "P": 4, "HS": 6, "HSem": 96 },
        { "disciplina": "Matemática Financeira I", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 },
        { "disciplina": "Macroeconomia I", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 },
        { "disciplina": "Optativa I - Gestão Fiscal e Tributária", "T": 0, "TP": 2, "P": 0, "HS": 2, "HSem": 32 }
      ],
      "6º Semestre (16 semanas)": [
        { "disciplina": "Direito Comercial", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 },
        { "disciplina": "Economia do Desenvolvimento", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 },
        { "disciplina": "Optativa II - Métodos de Previsão", "T": 0, "TP": 2, "P": 0, "HS": 2, "HSem": 32 },
        { "disciplina": "Contabilidade Nacional", "T": 0, "TP": 2, "P": 0, "HS": 2, "HSem": 32 },
        { "disciplina": "Economia Monetária", "T": 2, "TP": 0, "P": 0, "HS": 2, "HSem": 32 },
        { "disciplina": "Optativa - Métodos Quantitativos", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 },
        { "disciplina": "Gestão Financeira", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 },
        { "disciplina": "Matemática Financeira II", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 },
        { "disciplina": "Macroeconomia II", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 }
      ]
    },
    "4º Ano": {
      "7º Semestre (16 semanas)": [
        { "disciplina": "Direito Económico", "T": 2, "TP": 0, "P": 4, "HS": 6, "HSem": 96 },
        { "disciplina": "Economia Internacional", "T": 2, "TP": 0, "P": 4, "HS": 6, "HSem": 96 },
        { "disciplina": "Moeda e Crédito", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 },
        { "disciplina": "Seminário - Avaliação de Projectos I", "T": 2, "TP": 0, "P": 4, "HS": 6, "HSem": 96 },
        { "disciplina": "Monografia I", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 }
      ],
      "8º Semestre (16 semanas)": [
        { "disciplina": "Política Económica", "T": 2, "TP": 0, "P": 4, "HS": 6, "HSem": 96 },
        { "disciplina": "Economia da África Sub-", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 },
        { "disciplina": "Monografia II", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 },
        { "disciplina": "Oratória", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 },
        { "disciplina": "Seminário - Avaliação de Projectos II", "T": 2, "TP": 0, "P": 4, "HS": 6, "HSem": 96 }
      ]
    }
  },
  "requisitos": "12ª Ano concluída",
  "linkInscricao": "https://portalonline.icsgisabelinha.com/Publico/Candidaturas/Candidatura"
},
{
  "id": 10,
  "title": "Licenciatura em Engenharia Civil",
  "duration": "5 anos",
  "description": "Formação em Engenharia Civil: domine o projeto, construção e gestão de infraestruturas civis para uma carreira sólida no sector da construção",
  "detalhes": "Estudo aprofundado de estruturas, materiais de construção, hidráulica, geotecnia e gestão de obras. Desenvolva competências para projetar e gerir projetos de engenharia civil.",
  "path": "/programas/licenciatura/detalhes-cursos/10",
  "images": [
    require('../../assets/ANU_02.jpg'),
    require('../../assets/ANU_02.jpg'),
  ],
  "objetivos": [
    'Formar engenheiros civis com sólida base teórica e prática',
    'Desenvolver competências em projeto e construção de infraestruturas',
    'Preparar profissionais para gestão de obras e projetos de engenharia'
  ],
  "planoCurricularCompleto": {
    "1º Ano": {
      "1º Semestre (16 semanas)": [
        { "disciplina": "Língua Portuguesa", "T": 2, "TP": 0, "P": 0, "HS": 2, "HSem": 32 },
        { "disciplina": "Química Geral", "T": 2, "TP": 2, "P": 0, "HS": 4, "HSem": 64 },
        { "disciplina": "Probabilidade e Estatística", "T": 2, "TP": 2, "P": 0, "HS": 4, "HSem": 64 },
        { "disciplina": "Geometria Descritiva", "T": 2, "TP": 2, "P": 0, "HS": 4, "HSem": 64 },
        { "disciplina": "Análise Matemática I", "T": 2, "TP": 2, "P": 0, "HS": 4, "HSem": 64 },
        { "disciplina": "Física I", "T": 2, "TP": 2, "P": 0, "HS": 4, "HSem": 64 },
        { "disciplina": "Álgebra Linear e Geometria Analítica", "T": 2, "TP": 2, "P": 0, "HS": 4, "HSem": 64 },
        { "disciplina": "Metodologia de Investigação Científica", "T": 2, "TP": 2, "P": 0, "HS": 2, "HSem": 32 }
      ],
      "2º Semestre (16 semanas)": [
        { "disciplina": "Análise Numérica", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 },
        { "disciplina": "Mecânica Aplicada", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 },
        { "disciplina": "Análise Matemática II", "T": 2, "TP": 2, "P": 0, "HS": 4, "HSem": 64 },
        { "disciplina": "Física I", "T": 2, "TP": 2, "P": 0, "HS": 4, "HSem": 64 },
        { "disciplina": "Desenho de Construção Civil e Arquitetura", "T": 2, "TP": 2, "P": 0, "HS": 4, "HSem": 64 },
        { "disciplina": "Topografia Geral", "T": 2, "TP": 2, "P": 0, "HS": 4, "HSem": 64 },
        { "disciplina": "Metodologia de Investigação Científica", "T": 2, "TP": 2, "P": 0, "HS": 4, "HSem": 64 }
      ]
    },
    "2º Ano": {
      "3º Semestre (16 semanas)": [
        { "disciplina": "Análise Matemática III", "T": 2, "TP": 2, "P": 0, "HS": 4, "HSem": 64 },
        { "disciplina": "Física III", "T": 2, "TP": 2, "P": 0, "HS": 4, "HSem": 64 },
        { "disciplina": "Geologia Geral", "T": 2, "TP": 2, "P": 0, "HS": 4, "HSem": 64 },
        { "disciplina": "Materiais de Construção I", "T": 2, "TP": 2, "P": 2, "HS": 6, "HSem": 96 },
        { "disciplina": "Hidráulica I", "T": 2, "TP": 2, "P": 2, "HS": 6, "HSem": 96 },
        { "disciplina": "Resistência dos Materiais I", "T": 2, "TP": 2, "P": 2, "HS": 6, "HSem": 96 }
      ],
      "4º Semestre (16 semanas)": [
        { "disciplina": "Análise dos Solos e Fundações I", "T": 2, "TP": 2, "P": 2, "HS": 6, "HSem": 96 },
        { "disciplina": "Física dos Meios Contínuos", "T": 2, "TP": 2, "P": 2, "HS": 6, "HSem": 96 },
        { "disciplina": "Planeamento Regional e Urbano", "T": 2, "TP": 2, "P": 2, "HS": 6, "HSem": 96 },
        { "disciplina": "Materiais de Construção II", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 },
        { "disciplina": "Hidráulica II", "T": 2, "TP": 2, "P": 2, "HS": 6, "HSem": 96 },
        { "disciplina": "Resistência dos Materiais II", "T": 0, "TP": 0, "P": 0, "HS": 0, "HSem": 0 }
      ]
    },
    "3º Ano": {
      "5º Semestre (16 semanas)": [
        { "disciplina": "Mecânica dos Solos e Fundações I", "T": 2, "TP": 2, "P": 2, "HS": 6, "HSem": 96 },
        { "disciplina": "Teoria das Estruturas I", "T": 2, "TP": 2, "P": 2, "HS": 6, "HSem": 96 },
        { "disciplina": "Vias de Comunicação I", "T": 2, "TP": 2, "P": 2, "HS": 6, "HSem": 96 },
        { "disciplina": "Tecnologia de Construção I", "T": 2, "TP": 2, "P": 2, "HS": 6, "HSem": 96 },
        { "disciplina": "Instalações Hidráulicas em Edifícios", "T": 2, "TP": 2, "P": 2, "HS": 6, "HSem": 96 }
      ],
      "6º Semestre (16 semanas)": [
        { "disciplina": "Mecânica dos Solos e Fundações II", "T": 2, "TP": 2, "P": 2, "HS": 6, "HSem": 96 },
        { "disciplina": "Teoria das Estruturas II", "T": 2, "TP": 2, "P": 2, "HS": 6, "HSem": 96 },
        { "disciplina": "Vias de Comunicação II", "T": 2, "TP": 2, "P": 2, "HS": 6, "HSem": 96 },
        { "disciplina": "Tecnologias de Construção II", "T": 2, "TP": 2, "P": 2, "HS": 6, "HSem": 96 },
        { "disciplina": "Instalações Elétricas em Edifícios", "T": 2, "TP": 2, "P": 2, "HS": 6, "HSem": 96 }
      ]
    },
    "4º Ano": {
      "7º Semestre (16 semanas)": [
        { "disciplina": "Betão Armado e Pré-esforçado I", "T": 2, "TP": 4, "P": 4, "HS": 10, "HSem": 160 },
        { "disciplina": "Gestão e Estaleiros de Obra I", "T": 2, "TP": 2, "P": 2, "HS": 6, "HSem": 96 },
        { "disciplina": "Modelação e Análise de Estruturas", "T": 2, "TP": 2, "P": 2, "HS": 6, "HSem": 96 },
        { "disciplina": "Caminhos-de-ferro", "T": 2, "TP": 2, "P": 2, "HS": 6, "HSem": 96 },
        { "disciplina": "Estruturas Metálicas e Mistas", "T": 0, "TP": 0, "P": 0, "HS": 0, "HSem": 0 }
      ],
      "8º Semestre (16 semanas)": [
        { "disciplina": "Betão Armado e Pré-esforçado II", "T": 2, "TP": 4, "P": 4, "HS": 10, "HSem": 160 },
        { "disciplina": "Gestão e Estaleiros de Obra II", "T": 2, "TP": 2, "P": 2, "HS": 6, "HSem": 96 },
        { "disciplina": "Pontes", "T": 2, "TP": 2, "P": 2, "HS": 6, "HSem": 96 },
        { "disciplina": "Pavimento de Aeródromos", "T": 2, "TP": 2, "P": 2, "HS": 6, "HSem": 96 },
        { "disciplina": "Estruturas de Madeiras", "T": 0, "TP": 0, "P": 0, "HS": 0, "HSem": 0 }
      ]
    },
    "5º Ano": {
      "9º Semestre (16 semanas)": [
        { "disciplina": "Reabilitação e Reforço de Estruturas", "T": 3, "TP": 3, "P": 3, "HS": 9, "HSem": 144 },
        { "disciplina": "Gestão e Resolução dos Solos e Impacto Ambiental", "T": 2, "TP": 2, "P": 2, "HS": 6, "HSem": 96 },
        { "disciplina": "Economia da Construção", "T": 2, "TP": 2, "P": 2, "HS": 6, "HSem": 96 },
        { "disciplina": "Investigação Operacional", "T": 2, "TP": 2, "P": 0, "HS": 4, "HSem": 64 },
        { "disciplina": "Dimensionamento de Estruturas", "T": 2, "TP": 2, "P": 0, "HS": 4, "HSem": 64 }
      ],
      "10º Semestre (16 semanas)": [
        { "disciplina": "Estágio", "T": 4, "TP": 8, "P": 8, "HS": 20, "HSem": 320 },
        { "disciplina": "Trabalho de Fim do Curso", "T": 4, "TP": 4, "P": 0, "HS": 8, "HSem": 128 }
      ]
    }
  },
  "requisitos": "12ª Ano concluída",
  "linkInscricao": "https://portalonline.icsgisabelinha.com/Publico/Candidaturas/Candidatura"
},
{
  "id": 11,
  "title": "Licenciatura em Farmácia",
  "duration": "5 anos",
  "description": "Formação em Ciências Farmacêuticas: domine a produção, controlo e dispensação de medicamentos para uma carreira sólida no sector da saúde",
  "detalhes": "Estudo aprofundado de química farmacêutica, farmacologia, tecnologia farmacêutica e gestão farmacêutica. Desenvolva competências para atuar em farmácia comunitária, hospitalar e indústria farmacêutica.",
  "path": "/programas/licenciatura/detalhes-cursos/11",
  "images": [
    require('../../assets/ANU_02.jpg'),
    require('../../assets/ANU_02.jpg'),
  ],
  "objetivos": [
    'Formar farmacêuticos com sólida base teórica e prática',
    'Desenvolver competências em tecnologia e controle de medicamentos',
    'Preparar profissionais para gestão farmacêutica e atenção farmacêutica'
  ],
  "planoCurricularCompleto": {
    "1º Ano": {
      "1º Semestre (16 semanas)": [
        { "disciplina": "Química Geral", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 },
        { "disciplina": "Biologia Celular e Molecular I", "T": 2, "TP": 2, "P": 0, "HS": 4, "HSem": 64 },
        { "disciplina": "Bioestatística", "T": 2, "TP": 2, "P": 0, "HS": 4, "HSem": 64 },
        { "disciplina": "Anatomia Humana", "T": 2, "TP": 2, "P": 0, "HS": 2, "HSem": 64 },
        { "disciplina": "Metodologia de Investigação Científica", "T": 2, "TP": 2, "P": 0, "HS": 4, "HSem": 32 },
        { "disciplina": "Introdução à Farmácia", "T": 2, "TP": 2, "P": 0, "HS": 4, "HSem": 64 },
        { "disciplina": "Língua Portuguesa", "T": 0, "TP": 2, "P": 0, "HS": 2, "HSem": 32 },
        { "disciplina": "Ética e Legislação", "T": 0, "TP": 2, "P": 0, "HS": 2, "HSem": 32 },
        { "disciplina": "Matemática Aplicada", "T": 0, "TP": 2, "P": 0, "HS": 2, "HSem": 32 },
        { "disciplina": "História e Citologia", "T": 0, "TP": 2, "P": 0, "HS": 2, "HSem": 32 }
      ],
      "2º Semestre (16 semanas)": [
        { "disciplina": "Botânica Farmacêutica", "T": 3, "TP": 0, "P": 3, "HS": 6, "HSem": 96 },
        { "disciplina": "Química Analítica e Métodos Instrumentais de Análise", "T": 3, "TP": 0, "P": 3, "HS": 6, "HSem": 96 },
        { "disciplina": "Anatomia Humana", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 },
        { "disciplina": "Metodologia de Investigação Científica", "T": 2, "TP": 2, "P": 0, "HS": 4, "HSem": 64 },
        { "disciplina": "Física Aplicada", "T": 2, "TP": 2, "P": 0, "HS": 4, "HSem": 64 },
        { "disciplina": "Química - Física", "T": 2, "TP": 0, "P": 0, "HS": 2, "HSem": 48 }
      ]
    },
    "2º Ano": {
      "3º Semestre (16 semanas)": [
        { "disciplina": "Química Farmacêutica", "T": 2, "TP": 2, "P": 2, "HS": 6, "HSem": 96 },
        { "disciplina": "Farmacognosia", "T": 2, "TP": 2, "P": 2, "HS": 6, "HSem": 96 },
        { "disciplina": "Inglês", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 },
        { "disciplina": "Informática", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 },
        { "disciplina": "Fisiologia Humana I", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 },
        { "disciplina": "Farmácia Galênica", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 }
      ],
      "4º Semestre (16 semanas)": [
        { "disciplina": "Química Farmacêutica", "T": 2, "TP": 2, "P": 2, "HS": 6, "HSem": 96 },
        { "disciplina": "Fisiologia Humana I", "T": 2, "TP": 2, "P": 2, "HS": 6, "HSem": 96 },
        { "disciplina": "Fisioterapia", "T": 2, "TP": 2, "P": 2, "HS": 6, "HSem": 96 },
        { "disciplina": "Tecnologia Farmacêutica I", "T": 2, "TP": 2, "P": 0, "HS": 4, "HSem": 64 },
        { "disciplina": "Bioquímica I", "T": 0, "TP": 4, "P": 0, "HS": 4, "HSem": 64 },
        { "disciplina": "Farmacologia I", "T": 2, "TP": 2, "P": 0, "HS": 4, "HSem": 64 }
      ]
    },
    "3º Ano": {
      "5º Semestre (16 semanas)": [
        { "disciplina": "Psicologia Avançada", "T": 2, "TP": 2, "P": 2, "HS": 6, "HSem": 96 },
        { "disciplina": "Bioquímica II", "T": 2, "TP": 2, "P": 2, "HS": 6, "HSem": 96 },
        { "disciplina": "Farmacologia II", "T": 2, "TP": 2, "P": 0, "HS": 4, "HSem": 64 },
        { "disciplina": "Estágio de Aprendizagem", "T": 0, "TP": 4, "P": 0, "HS": 4, "HSem": 64 },
        { "disciplina": "Fisiologia Humana", "T": 2, "TP": 2, "P": 2, "HS": 6, "HSem": 96 }
      ],
      "6º Semestre (16 semanas)": [
        { "disciplina": "Organização e Gestão de Farmácia", "T": 2, "TP": 2, "P": 2, "HS": 6, "HSem": 96 },
        { "disciplina": "Farmacoterapia", "T": 2, "TP": 2, "P": 2, "HS": 6, "HSem": 96 },
        { "disciplina": "Toxicologia e Análise Toxicológicas", "T": 2, "TP": 2, "P": 2, "HS": 6, "HSem": 96 },
        { "disciplina": "Saúde Pública", "T": 0, "TP": 4, "P": 0, "HS": 4, "HSem": 64 },
        { "disciplina": "Tecnologia Farmacêutica II", "T": 2, "TP": 2, "P": 2, "HS": 6, "HSem": 96 }
      ]
    },
    "4º Ano": {
      "7º Semestre (16 semanas)": [
        { "disciplina": "Controlo da Qualidade do Medicamento", "T": 2, "TP": 2, "P": 2, "HS": 6, "HSem": 96 },
        { "disciplina": "Medicamentos e Aditivos Veterinários", "T": 2, "TP": 2, "P": 2, "HS": 6, "HSem": 96 },
        { "disciplina": "Biofarmácia e Farmacocinética", "T": 2, "TP": 2, "P": 2, "HS": 6, "HSem": 96 },
        { "disciplina": "Dermofarmácia e Cosmética", "T": 2, "TP": 2, "P": 2, "HS": 6, "HSem": 96 },
        { "disciplina": "Bioquímica Clínica", "T": 2, "TP": 2, "P": 2, "HS": 6, "HSem": 96 }
      ],
      "8º Semestre (16 semanas)": [
        { "disciplina": "Bromatologia e Hidrologia", "T": 2, "TP": 2, "P": 2, "HS": 6, "HSem": 96 },
        { "disciplina": "Farmácia Hospitalar", "T": 2, "TP": 2, "P": 2, "HS": 6, "HSem": 96 },
        { "disciplina": "Epidemiologia", "T": 2, "TP": 2, "P": 2, "HS": 6, "HSem": 96 },
        { "disciplina": "Farmácia Clínica", "T": 2, "TP": 2, "P": 2, "HS": 6, "HSem": 96 },
        { "disciplina": "Deontologia e Legislação", "T": 2, "TP": 2, "P": 2, "HS": 6, "HSem": 96 }
      ]
    },
    "5º Ano": {
      "9º Semestre (16 semanas)": [
        { "disciplina": "Fisiopatologia Humana", "T": 3, "TP": 0, "P": 3, "HS": 9, "HSem": 144 },
        { "disciplina": "Farmácia Hospitalar", "T": 3, "TP": 0, "P": 3, "HS": 9, "HSem": 144 },
        { "disciplina": "Estágio", "T": 3, "TP": 3, "P": 3, "HS": 6, "HSem": 96 },
        { "disciplina": "Bioquímica", "T": 3, "TP": 3, "P": 3, "HS": 6, "HSem": 96 }
      ],
      "10º Semestre (16 semanas)": [
        { "disciplina": "Projectos", "T": 0, "TP": 20, "P": 0, "HS": 20, "HSem": 320 },
        { "disciplina": "Estágio", "T": 0, "TP": 10, "P": 0, "HS": 10, "HSem": 160 }
      ]
    }
  },
  "requisitos": "12ª Ano concluída",
  "linkInscricao": "https://portalonline.icsgisabelinha.com/Publico/Candidaturas/Candidatura"
},
{
  "id": 12,
  "title": "Licenciatura em Gestão de Recursos Humanos",
  "duration": "4 anos",
  "description": "Formação em Gestão de Recursos Humanos: domine a gestão estratégica de pessoas, desenvolvimento organizacional e relações laborais para uma carreira sólida no sector empresarial",
  "detalhes": "Estudo aprofundado de gestão de RH, comportamento organizacional, direito do trabalho, formação e desenvolvimento de pessoas. Desenvolva competências para gerir talentos e estratégias de recursos humanos.",
  "path": "/programas/licenciatura/detalhes-cursos/12",
  "images": [
    require('../../assets/ANU_02.jpg'),
    require('../../assets/ANU_02.jpg'),
  ],
  "objetivos": [
    'Formar gestores de recursos humanos com sólida base teórica e prática',
    'Desenvolver competências em gestão estratégica de pessoas',
    'Preparar profissionais para relações laborais e desenvolvimento organizacional'
  ],
  "planoCurricularCompleto": {
    "1º Ano": {
      "1º Semestre (16 semanas)": [
        { "disciplina": "Informática", "T": 2, "TP": 2, "P": 0, "HS": 64, "HSem": 4 },
        { "disciplina": "Língua Portuguesa", "T": 2, "TP": 2, "P": 0, "HS": 64, "HSem": 4 },
        { "disciplina": "Metodologia de Investigação Científica", "T": 2, "TP": 2, "P": 0, "HS": 64, "HSem": 4 },
        { "disciplina": "Fundamento do Pensamento Contemporâneo", "T": 2, "TP": 2, "P": 0, "HS": 64, "HSem": 4 },
        { "disciplina": "Teoria Geral de Administração", "T": 2, "TP": 2, "P": 0, "HS": 64, "HSem": 4 },
        { "disciplina": "Inglês I", "T": 2, "TP": 2, "P": 0, "HS": 64, "HSem": 4 },
        { "disciplina": "Psicologia Geral I", "T": 2, "TP": 2, "P": 0, "HS": 64, "HSem": 4 }
      ],
      "2º Semestre (16 semanas)": [
        { "disciplina": "Língua Portuguesa", "T": 2, "TP": 2, "P": 0, "HS": 64, "HSem": 4 },
        { "disciplina": "Antropologia Geral", "T": 2, "TP": 2, "P": 0, "HS": 64, "HSem": 4 },
        { "disciplina": "Fundamento do Pensamento Contemporâneo", "T": 2, "TP": 2, "P": 0, "HS": 64, "HSem": 4 },
        { "disciplina": "Ética e Deontologia Profissional", "T": 2, "TP": 2, "P": 0, "HS": 64, "HSem": 4 },
        { "disciplina": "Psicologia Geral II", "T": 2, "TP": 2, "P": 0, "HS": 64, "HSem": 4 },
        { "disciplina": "Inglês II", "T": 2, "TP": 2, "P": 0, "HS": 64, "HSem": 4 },
        { "disciplina": "Metodologia da Investigação Científica II", "T": 2, "TP": 2, "P": 0, "HS": 64, "HSem": 4 }
      ]
    },
    "2º Ano": {
      "3º Semestre (16 semanas)": [
        { "disciplina": "Fundamentos da Economia", "T": 2, "TP": 2, "P": 0, "HS": 64, "HSem": 4 },
        { "disciplina": "Sociologia das Organizações", "T": 2, "TP": 2, "P": 0, "HS": 64, "HSem": 4 },
        { "disciplina": "Estatística I", "T": 2, "TP": 2, "P": 2, "HS": 96, "HSem": 6 },
        { "disciplina": "História Geral da África", "T": 2, "TP": 2, "P": 0, "HS": 64, "HSem": 4 },
        { "disciplina": "Gestão dos Recursos Humanos I", "T": 2, "TP": 2, "P": 2, "HS": 96, "HSem": 6 },
        { "disciplina": "Direito do Trabalho I", "T": 2, "TP": 2, "P": 0, "HS": 64, "HSem": 4 }
      ],
      "4º Semestre (16 semanas)": [
        { "disciplina": "Métodos Quantitativos", "T": 2, "TP": 2, "P": 0, "HS": 64, "HSem": 4 },
        { "disciplina": "Instituições e Políticas da União Africana", "T": 2, "TP": 0, "P": 0, "HS": 32, "HSem": 2 },
        { "disciplina": "Gestão dos Recursos Humanos II", "T": 2, "TP": 2, "P": 2, "HS": 96, "HSem": 6 },
        { "disciplina": "Psicologia Organizacional", "T": 2, "TP": 2, "P": 0, "HS": 64, "HSem": 4 },
        { "disciplina": "Estatística II", "T": 2, "TP": 2, "P": 2, "HS": 96, "HSem": 6 },
        { "disciplina": "Direito do Trabalho II", "T": 2, "TP": 2, "P": 0, "HS": 64, "HSem": 4 },
        { "disciplina": "Comportamento Organizacional I", "T": 2, "TP": 2, "P": 0, "HS": 64, "HSem": 4 }
      ]
    },
    "3º Ano": {
      "5º Semestre (16 semanas)": [
        { "disciplina": "Comunicação Institucional", "T": 2, "TP": 2, "P": 0, "HS": 64, "HSem": 4 },
        { "disciplina": "Estratégia Empresarial", "T": 2, "TP": 2, "P": 2, "HS": 96, "HSem": 6 },
        { "disciplina": "Formação e Desenvolvimento de Recursos Humanos", "T": 2, "TP": 2, "P": 0, "HS": 64, "HSem": 4 },
        { "disciplina": "Gestão de Recursos Humanos III", "T": 2, "TP": 2, "P": 2, "HS": 96, "HSem": 6 },
        { "disciplina": "Comportamento Organizacional II", "T": 2, "TP": 2, "P": 2, "HS": 64, "HSem": 4 },
        { "disciplina": "Direito do Trabalho III", "T": 2, "TP": 2, "P": 0, "HS": 96, "HSem": 6 }
      ],
      "6º Semestre (16 semanas)": [
        { "disciplina": "Lei da Segurança Social", "T": 2, "TP": 2, "P": 0, "HS": 4, "HSem": 64 },
        { "disciplina": "Psicologia das Relações Laborais", "T": 2, "TP": 2, "P": 0, "HS": 4, "HSem": 64 },
        { "disciplina": "Fiscalidade Angolana", "T": 2, "TP": 2, "P": 0, "HS": 4, "HSem": 64 },
        { "disciplina": "Economia do Trabalho", "T": 2, "TP": 2, "P": 2, "HS": 6, "HSem": 96 },
        { "disciplina": "Planeamento Estratégico de Recursos Humanos", "T": 2, "TP": 2, "P": 2, "HS": 6, "HSem": 96 },
        { "disciplina": "Informática da Gestão de Recursos Humanos", "T": 2, "TP": 2, "P": 2, "HS": 6, "HSem": 96 }
      ]
    },
    "4º Ano": {
      "7º Semestre (16 semanas)": [
        { "disciplina": "Estratégia Empresarial", "T": 2, "TP": 2, "P": 0, "HS": 64, "HSem": 4 },
        { "disciplina": "Gestão dos Recursos Humanos na Administração Pública", "T": 2, "TP": 2, "P": 2, "HS": 96, "HSem": 6 },
        { "disciplina": "Administração Pública Angolana", "T": 2, "TP": 2, "P": 0, "HS": 64, "HSem": 4 },
        { "disciplina": "Diagnóstico e Mudança Organizacional", "T": 2, "TP": 2, "P": 0, "HS": 64, "HSem": 4 },
        { "disciplina": "Gestão do Desempenho e do Potencial", "T": 2, "TP": 2, "P": 0, "HS": 64, "HSem": 4 },
        { "disciplina": "Seminários I", "T": 2, "TP": 0, "P": 2, "HS": 64, "HSem": 4 },
        { "disciplina": "Monografia I", "T": 2, "TP": 2, "P": 0, "HS": 64, "HSem": 4 }
      ],
      "8º Semestre (16 semanas)": [
        { "disciplina": "Ética e Responsabilidade Social", "T": 2, "TP": 0, "P": 2, "HS": 64, "HSem": 4 },
        { "disciplina": "Gestão Nacional de Recursos Humanos", "T": 2, "TP": 0, "P": 2, "HS": 64, "HSem": 4 },
        { "disciplina": "Estatística Aplicada aos Recursos Humanos", "T": 2, "TP": 2, "P": 0, "HS": 64, "HSem": 4 },
        { "disciplina": "Recursos Humanos e Contexto Nacional Angolano", "T": 2, "TP": 2, "P": 2, "HS": 96, "HSem": 6 },
        { "disciplina": "Avaliação de Desempenho", "T": 2, "TP": 2, "P": 0, "HS": 64, "HSem": 4 },
        { "disciplina": "Seminários II", "T": 2, "TP": 0, "P": 2, "HS": 64, "HSem": 4 },
        { "disciplina": "Monografia II", "T": 2, "TP": 2, "P": 0, "HS": 64, "HSem": 4 }
      ]
    }
  },
  "requisitos": "12ª Ano concluída",
  "linkInscricao": "https://portalonline.icsgisabelinha.com/Publico/Candidaturas/Candidatura"
},
{
  "id": 13,
  "title": "Licenciatura em Psicologia",
  "duration": "4 anos",
  "description": "Formação em Psicologia: domine os processos psicológicos, avaliação e intervenção psicológica para uma carreira sólida na área da saúde mental e educação",
  "detalhes": "Estudo aprofundado do comportamento humano, processos cognitivos, desenvolvimento psicológico e técnicas de intervenção. Desenvolva competências para atuar em contextos clínicos, educacionais e organizacionais.",
  "path": "/programas/licenciatura/detalhes-cursos/13",
  "images": [
    require('../../assets/ANU_02.jpg'),
    require('../../assets/ANU_02.jpg'),
  ],
  "objetivos": [
    'Formar psicólogos com sólida base teórica e prática',
    'Desenvolver competências em avaliação e intervenção psicológica',
    'Preparar profissionais para atuação em diversos contextos psicológicos'
  ],
  "planoCurricularCompleto": {
    "1º Ano": {
      "1º Semestre (16 semanas)": [
        { "disciplina": "Anatomia e Fisiologia Humana", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 },
        { "disciplina": "Inglês", "T": 2, "TP": 0, "P": 0, "HS": 2, "HSem": 32 },
        { "disciplina": "Informática", "T": 2, "TP": 0, "P": 0, "HS": 2, "HSem": 32 },
        { "disciplina": "Língua Portuguesa", "T": 0, "TP": 2, "P": 0, "HS": 2, "HSem": 32 },
        { "disciplina": "Filosofia Geral", "T": 0, "TP": 2, "P": 0, "HS": 2, "HSem": 32 },
        { "disciplina": "História da Psicologia", "T": 2, "TP": 2, "P": 0, "HS": 2, "HSem": 32 },
        { "disciplina": "Psicologia Geral", "T": 2, "TP": 2, "P": 0, "HS": 2, "HSem": 32 },
        { "disciplina": "Introdução à Técnica de Comunicação", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 },
        { "disciplina": "Metodologia de Investigação Científica", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 },
        { "disciplina": "Pedagogia Geral", "T": 2, "TP": 0, "P": 0, "HS": 2, "HSem": 32 }
      ],
      "2º Semestre (16 semanas)": [
        { "disciplina": "Inglês", "T": 2, "TP": 0, "P": 0, "HS": 2, "HSem": 32 },
        { "disciplina": "Informática", "T": 2, "TP": 0, "P": 0, "HS": 2, "HSem": 32 },
        { "disciplina": "Língua Portuguesa", "T": 2, "TP": 0, "P": 0, "HS": 2, "HSem": 32 },
        { "disciplina": "Lógica Formal", "T": 2, "TP": 2, "P": 0, "HS": 4, "HSem": 64 },
        { "disciplina": "Psicofisiologia", "T": 2, "TP": 2, "P": 0, "HS": 4, "HSem": 48 },
        { "disciplina": "História da Psicologia", "T": 2, "TP": 2, "P": 0, "HS": 4, "HSem": 48 },
        { "disciplina": "Psicologia Geral", "T": 2, "TP": 2, "P": 0, "HS": 4, "HSem": 64 },
        { "disciplina": "Metodologia de Investigação Científica", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 48 },
        { "disciplina": "Pedagogia Geral", "T": 2, "TP": 0, "P": 0, "HS": 2, "HSem": 48 }
      ]
    },
    "2º Ano": {
      "3º Semestre (16 semanas)": [
        { "disciplina": "Psicologia do Desenvolvimento", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 },
        { "disciplina": "Sociologia Geral", "T": 2, "TP": 0, "P": 0, "HS": 2, "HSem": 32 },
        { "disciplina": "Psicologia Pedagógica", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 },
        { "disciplina": "História de Angola", "T": 2, "TP": 0, "P": 0, "HS": 2, "HSem": 32 },
        { "disciplina": "Língua Portuguesa II", "T": 2, "TP": 2, "P": 0, "HS": 4, "HSem": 64 },
        { "disciplina": "Inglês II", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 },
        { "disciplina": "Didáctica Geral", "T": 2, "TP": 2, "P": 0, "HS": 4, "HSem": 64 },
        { "disciplina": "Teoria da Educação", "T": 2, "TP": 2, "P": 0, "HS": 4, "HSem": 64 },
        { "disciplina": "Estatística Aplicada à Educação", "T": 0, "TP": 2, "P": 0, "HS": 2, "HSem": 32 }
      ],
      "4º Semestre (16 semanas)": [
        { "disciplina": "Psicologia do Desenvolvimento", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 },
        { "disciplina": "Demografia", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 },
        { "disciplina": "Ética e Deontologia Profissional", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 },
        { "disciplina": "Língua Portuguesa", "T": 2, "TP": 2, "P": 0, "HS": 4, "HSem": 64 },
        { "disciplina": "Inglês II", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 },
        { "disciplina": "Didáctica Geral", "T": 2, "TP": 2, "P": 0, "HS": 4, "HSem": 64 },
        { "disciplina": "Teoria da Educação", "T": 2, "TP": 2, "P": 0, "HS": 4, "HSem": 64 }
      ]
    },
    "3º Ano": {
      "5º Semestre (16 semanas)": [
        { "disciplina": "Terapia Familiar", "T": 1, "TP": 0, "P": 1, "HS": 2, "HSem": 32 },
        { "disciplina": "Prática e Construção de Teste", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 },
        { "disciplina": "Epistemologia Genética", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 },
        { "disciplina": "Didáctica Especial da Psicologia", "T": 0, "TP": 2, "P": 0, "HS": 2, "HSem": 32 },
        { "disciplina": "Psicologia de Criança e o Adolescente", "T": 0, "TP": 2, "P": 0, "HS": 2, "HSem": 32 },
        { "disciplina": "Orientação Escolar Profissional", "T": 1, "TP": 0, "P": 1, "HS": 2, "HSem": 32 },
        { "disciplina": "Filosofia da Educação", "T": 1, "TP": 0, "P": 1, "HS": 2, "HSem": 32 },
        { "disciplina": "Legislação Escolar de Organização de Sistema Escolar", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 },
        { "disciplina": "Questão Aprofundadas de Estatística", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 },
        { "disciplina": "Ergonomia e Análise Psicológico do Desenvolvimento", "T": 1, "TP": 0, "P": 1, "HS": 2, "HSem": 32 },
        { "disciplina": "Problemas de Inadaptação Escolar", "T": 1, "TP": 0, "P": 1, "HS": 2, "HSem": 32 }
      ],
      "6º Semestre (16 semanas)": [
        { "disciplina": "Terapia Familiar", "T": 1, "TP": 0, "P": 1, "HS": 2, "HSem": 32 },
        { "disciplina": "Psicologia Social", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 },
        { "disciplina": "Psicologia Criminal", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 },
        { "disciplina": "Prática e Construção de Teste", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 },
        { "disciplina": "Métodos e Técnicas Projectivas", "T": 2, "TP": 2, "P": 0, "HS": 4, "HSem": 64 },
        { "disciplina": "Consulta Diagnostico-Psicológica", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 },
        { "disciplina": "Questão Aprofundadas de Estatística", "T": 1, "TP": 0, "P": 1, "HS": 2, "HSem": 32 },
        { "disciplina": "Prática Pedagógica I", "T": 1, "TP": 0, "P": 1, "HS": 2, "HSem": 32 },
        { "disciplina": "Gestão e Inspecção Educativa", "T": 2, "TP": 0, "P": 0, "HS": 2, "HSem": 32 },
        { "disciplina": "Relatório", "T": 1, "TP": 0, "P": 1, "HS": 2, "HSem": 32 }
      ]
    },
    "4º Ano": {
      "7º Semestre (16 semanas)": [
        { "disciplina": "Psicologia Legal", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 },
        { "disciplina": "Psicopatologia", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 },
        { "disciplina": "Dinâmica de Grupo", "T": 2, "TP": 0, "P": 0, "HS": 2, "HSem": 32 },
        { "disciplina": "Cultura e Personalidade", "T": 2, "TP": 0, "P": 0, "HS": 2, "HSem": 32 },
        { "disciplina": "Modelos e Métodos de Comportamento Psicológico", "T": 2, "TP": 2, "P": 2, "HS": 4, "HSem": 64 },
        { "disciplina": "Organização e Gestão de Higiene Escolar", "T": 2, "TP": 2, "P": 2, "HS": 4, "HSem": 64 },
        { "disciplina": "Técnicas de Exame e Aconselhamento", "T": 2, "TP": 0, "P": 0, "HS": 4, "HSem": 64 },
        { "disciplina": "Psicologia Escolar e Problemas de Aprendizagem", "T": 2, "TP": 0, "P": 0, "HS": 4, "HSem": 64 },
        { "disciplina": "Desenvolvimento Curricular", "T": 2, "TP": 0, "P": 0, "HS": 0, "HSem": 32 }
      ],
      "8º Semestre (16 semanas)": [
        { "disciplina": "Psicopatologia", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 },
        { "disciplina": "Dinâmica de Grupo", "T": 2, "TP": 0, "P": 0, "HS": 2, "HSem": 32 },
        { "disciplina": "Intervenção Psicológica", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 },
        { "disciplina": "Modelos e Métodos de Comportamento Psicológico", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 },
        { "disciplina": "Estudo de Mercado de Trabalho", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 },
        { "disciplina": "Trabalho do Fim do Curso", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 },
        { "disciplina": "Psicologia Escolar e Problemas de Aprendizagem", "T": 2, "TP": 2, "P": 0, "HS": 4, "HSem": 64 },
        { "disciplina": "Prática Pedagógica II", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 }
      ]
    }
  },
  "requisitos": "12ª Ano concluída",
  "linkInscricao": "https://portalonline.icsgisabelinha.com/Publico/Candidaturas/Candidatura"
},
{
  "id": 14,
  "title": "Licenciatura em Relações Internacionais",
  "duration": "4 anos",
  "description": "Formação em Relações Internacionais: domine a análise política internacional, diplomacia e negociação para uma carreira sólida no cenário global",
  "detalhes": "Estudo aprofundado de política internacional, direito internacional, economia global e diplomacia. Desenvolva competências para atuar em organizações internacionais, diplomacia e comércio exterior.",
  "path": "/programas/licenciatura/detalhes-cursos/14",
  "images": [
    require('../../assets/ANU_02.jpg'),
    require('../../assets/ANU_02.jpg'),
  ],
  "objetivos": [
    'Formar internacionalistas com sólida base teórica e prática',
    'Desenvolver competências em análise política internacional e diplomacia',
    'Preparar profissionais para atuação em organizações internacionais e relações exteriores'
  ],
  "planoCurricularCompleto": {
    "1º Ano": {
      "1º Semestre (16 semanas)": [
        { "disciplina": "Informática", "T": 0, "TP": 2, "P": 0, "HS": 2, "HSem": 32 },
        { "disciplina": "Inglês I", "T": 0, "TP": 2, "P": 0, "HS": 2, "HSem": 32 },
        { "disciplina": "Técnicas de Expressão", "T": 0, "TP": 3, "P": 0, "HS": 2, "HSem": 48 },
        { "disciplina": "Direito I", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 },
        { "disciplina": "Relações Internacionais I", "T": 3, "TP": 0, "P": 3, "HS": 6, "HSem": 96 },
        { "disciplina": "Estatística", "T": 1, "TP": 0, "P": 1, "HS": 2, "HSem": 32 },
        { "disciplina": "Economia I", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 },
        { "disciplina": "Metodologia de Investigação Científica", "T": 3, "TP": 0, "P": 3, "HS": 6, "HSem": 96 }
      ],
      "2º Semestre (16 semanas)": [
        { "disciplina": "Filosofia", "T": 0, "TP": 2, "P": 0, "HS": 2, "HSem": 32 },
        { "disciplina": "Inglês II", "T": 0, "TP": 2, "P": 0, "HS": 2, "HSem": 32 },
        { "disciplina": "Técnica de Expressão", "T": 0, "TP": 2, "P": 0, "HS": 2, "HSem": 32 },
        { "disciplina": "Direito II", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 },
        { "disciplina": "Relações Internacionais II", "T": 3, "TP": 0, "P": 3, "HS": 6, "HSem": 96 },
        { "disciplina": "Teoria da Comunicação", "T": 0, "TP": 2, "P": 0, "HS": 2, "HSem": 48 },
        { "disciplina": "Economia II", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 },
        { "disciplina": "Ética Profissional", "T": 1, "TP": 0, "P": 1, "HS": 2, "HSem": 32 },
        { "disciplina": "Metodologia de Investigação Científica", "T": 3, "TP": 0, "P": 3, "HS": 6, "HSem": 96 }
      ]
    },
    "2º Ano": {
      "3º Semestre (16 semanas)": [
        { "disciplina": "Direito Constitucional Angolano", "T": 2, "TP": 2, "P": 2, "HS": 6, "HSem": 96 },
        { "disciplina": "Direito Internacional Público I", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 },
        { "disciplina": "Economia Internacional", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 },
        { "disciplina": "Inglês III", "T": 0, "TP": 2, "P": 0, "HS": 2, "HSem": 32 },
        { "disciplina": "Ciência Política", "T": 0, "TP": 2, "P": 0, "HS": 2, "HSem": 32 },
        { "disciplina": "Psicologia Social", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 },
        { "disciplina": "História das Relações Internacionais I", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 },
        { "disciplina": "Teoria das Relações Internacionais I", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 }
      ],
      "4º Semestre (16 semanas)": [
        { "disciplina": "Geografia Política e Económica", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 },
        { "disciplina": "História de Angola", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 },
        { "disciplina": "Inglês IV", "T": 0, "TP": 2, "P": 0, "HS": 2, "HSem": 32 },
        { "disciplina": "História das Ideias Políticas", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 },
        { "disciplina": "Direito Administrativo", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 },
        { "disciplina": "Direito Internacional Público II", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 },
        { "disciplina": "História das Relações Internacionais II", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 },
        { "disciplina": "Teoria das Relações Internacionais II", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 }
      ]
    },
    "3º Ano": {
      "5º Semestre (16 semanas)": [
        { "disciplina": "Gestão e Resolução de Conflitos", "T": 2, "TP": 2, "P": 2, "HS": 6, "HSem": 96 },
        { "disciplina": "Direitos Humanos", "T": 2, "TP": 2, "P": 2, "HS": 6, "HSem": 96 },
        { "disciplina": "Organizações Internacionais I", "T": 2, "TP": 2, "P": 0, "HS": 4, "HSem": 64 },
        { "disciplina": "História da Diplomacia", "T": 3, "TP": 0, "P": 3, "HS": 6, "HSem": 96 },
        { "disciplina": "Direito Internacional Privado I", "T": 3, "TP": 0, "P": 3, "HS": 6, "HSem": 96 },
        { "disciplina": "Geopolítica e Geoestrategia I", "T": 0, "TP": 2, "P": 0, "HS": 2, "HSem": 32 }
      ],
      "6º Semestre (16 semanas)": [
        { "disciplina": "Integração e Blocos Regionais", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 },
        { "disciplina": "Política Externa de Angola", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 },
        { "disciplina": "Relações Internacionais Africanas", "T": 3, "TP": 3, "P": 0, "HS": 6, "HSem": 96 },
        { "disciplina": "Organizações Internacionais II", "T": 2, "TP": 2, "P": 0, "HS": 4, "HSem": 64 },
        { "disciplina": "Direito Internacional Privado II", "T": 3, "TP": 0, "P": 3, "HS": 6, "HSem": 96 },
        { "disciplina": "Geopolítica e Geoestrategia II", "T": 0, "TP": 2, "P": 0, "HS": 2, "HSem": 32 },
        { "disciplina": "História de África e dos PALOP", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 },
      ]
    },
    "4º Ano": {
      "7º Semestre (16 semanas)": [
        { "disciplina": "Análise Económica e Financeira", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 },
        { "disciplina": "Direito Diplomático e Consultar", "T": 2, "TP": 2, "P": 2, "HS": 6, "HSem": 96 },
        { "disciplina": "Teoria e Técnicas de Negociação Internacional", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 },
        { "disciplina": "Marketing", "T": 1, "TP": 3, "P": 0, "HS": 4, "HSem": 64 },
        { "disciplina": "Contabilidade", "T": 2, "TP": 2, "P": 0, "HS": 4, "HSem": 64 },
        { "disciplina": "Seminários sobre Problemas Internacionais Actuais", "T": 0, "TP": 2, "P": 2, "HS": 4, "HSem": 64 },
        { "disciplina": "Monografia", "T": 2, "TP": 2, "P": 0, "HS": 4, "HSem": 480 }
      ],
      "8º Semestre (16 semanas)": [
        { "disciplina": "Direito Reais", "T": 2, "TP": 2, "P": 2, "HS": 6, "HSem": 96 },
        { "disciplina": "Banca e Finanças Internacionais", "T": 2, "TP": 2, "P": 2, "HS": 6, "HSem": 96 },
        { "disciplina": "Marketing Internacional", "T": 1, "TP": 0, "P": 3, "HS": 4, "HSem": 64 },
        { "disciplina": "Mercados Financeiros", "T": 0, "TP": 2, "P": 0, "HS": 2, "HSem": 32 },
        { "disciplina": "Análise das Relações Internacionais", "T": 2, "TP": 0, "P": 2, "HS": 4, "HSem": 64 },
        { "disciplina": "Protocolo e Ceremonial", "T": 2, "TP": 2, "P": 0, "HS": 4, "HSem": 64 },
        { "disciplina": "Monografia", "T": 2, "TP": 2, "P": 0, "HS": 4, "HSem": 480 }
      ]
    }
  },
  "requisitos": "12ª Ano concluída",
  "linkInscricao": "https://portalonline.icsgisabelinha.com/Publico/Candidaturas/Candidatura"
},


];

// Componente para Plano Curricular
function PlanoCurricularSection({ planoCurricular, cursoTitle }) {
  return (
    <div className="mb-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h4 style={{ color: "#00761F", margin: 0 }}>
          <i className="fas fa-book me-2"></i>
          Plano Curricular Completo
        </h4>
      </div>
      
      {planoCurricular ? (
        Object.entries(planoCurricular).map(([ano, semestres]) => (
          <Card key={ano} className="mb-4" style={{ border: "1px solid #e0e0e0", borderRadius: "8px" }}>
            <Card.Header style={{ backgroundColor: "#00761F", color: "white", fontWeight: "bold" }}>
              {ano}
            </Card.Header>
            <Card.Body style={{ padding: 0 }}>
              {Object.entries(semestres).map(([semestre, disciplinas]) => (
                <div key={semestre} className="mb-3 p-3">
                  <h6 className="text-muted mb-3" style={{ color: "#555", fontWeight: "600" }}>
                    {semestre}
                  </h6>
                  <Table striped bordered hover responsive>
                    <thead style={{ backgroundColor: "#e8f5e9" }}>
                      <tr>
                        <th width="40%">Disciplinas</th>
                        <th width="10%">T</th>
                        <th width="10%">TP</th>
                        <th width="10%">P</th>
                        <th width="15%">HS</th>
                        <th width="15%">HSem</th>
                      </tr>
                    </thead>
                    <tbody>
                      {disciplinas.map((disciplina, index) => (
                        <tr key={index}>
                          <td style={{ fontWeight: "500" }}>{disciplina.disciplina}</td>
                          <td>{disciplina.T}</td>
                          <td>{disciplina.TP}</td>
                          <td>{disciplina.P}</td>
                          <td>{disciplina.HS}</td>
                          <td>{disciplina.HSem}</td>
                        </tr>
                      ))}
                      {/* Linha de totais */}
                      <tr style={{ backgroundColor: "#f8f9fa", fontWeight: "bold" }}>
                        <td>Sub-total de horas</td>
                        <td>{disciplinas.reduce((sum, d) => sum + (d.T || 0), 0)} </td>
                        <td>{disciplinas.reduce((sum, d) => sum + (d.TP || 0), 0)} </td>
                        <td>{disciplinas.reduce((sum, d) => sum + (d.P || 0), 0)}</td>
                        <td>{disciplinas.reduce((sum, d) => sum + (d.HS || 0), 0)}</td>
                        <td>{disciplinas.reduce((sum, d) => sum + (d.HSem || 0), 0)}</td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              ))}
            </Card.Body>
          </Card>
        ))
      ) : (
        <div className="text-center py-4">
          <i className="fas fa-exclamation-circle fa-2x text-muted mb-3"></i>
          <p>Plano curricular não disponível no momento.</p>
        </div>
      )}
    </div>
  );
}

export default function CursoDetalhes() {
  const { id } = useParams();
  const navigate = useNavigate();
  const curso = cursosData.find(c => c.id === parseInt(id));

  if (!curso) {
    return (
      <div style={{
        minHeight: "80vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background: "#fff"
      }}>
        <div style={{
          background: "#fff",
          borderRadius: "18px",
          boxShadow: "0 8px 32px rgba(60,60,120,0.12)",
          padding: "48px 32px",
          textAlign: "center",
          animation: "fadeIn 1s"
        }}>
          <svg
            width="80"
            height="80"
            viewBox="0 0 48 48"
            fill="none"
            style={{ marginBottom: 24, animation: "pageBounce 1.2s infinite" }}
          >
            <rect x="8" y="8" width="32" height="40" rx="6" fill="#00761F" />
            <rect x="14" y="16" width="20" height="4" rx="2" fill="#fff" />
            <rect x="14" y="24" width="16" height="4" rx="2" fill="#e8f5e9" />
            <rect x="14" y="32" width="12" height="4" rx="2" fill="#e8f5e9" />
            <rect x="8" y="8" width="32" height="8" rx="4" fill="#00c853" />
            <rect x="12" y="10" width="8" height="4" rx="2" fill="#fff" />
          </svg>
          <h2 style={{ marginBottom: 16, color: "#00761F" }}>Curso não encontrado</h2>
          <p style={{ marginBottom: 32, color: "#444" }}>
            Ops! O curso que você procura não existe ou foi removido.<br />
            Volte para a página de cursos e explore nossas opções!
          </p>
          <Button
            variant="success"
            size="lg"
            style={{
              borderRadius: "24px",
              padding: "12px 36px",
              fontWeight: 600,
              fontSize: "1.1rem",
              boxShadow: "0 2px 8px rgba(0,118,31,0.12)",
              backgroundColor: "#00761F",
              border: "none"
            }}
            onClick={() => navigate("/licenciaturas")}
          >
            ← Voltar para Cursos
          </Button>
        </div>
        <style>
          {`
            @keyframes fadeIn {
              from { opacity: 0; transform: translateY(40px);}
              to { opacity: 1; transform: translateY(0);}
            }
            @keyframes pageBounce {
              0%, 100% { transform: translateY(0);}
              50% { transform: translateY(-12px);}
            }
          `}
        </style>
      </div>
    );
  }

  return (
    <div>
      <BannerSection
        title={curso.title}
        subtitle="Descubra todos os detalhes sobre este curso"
        description={`Conheça em profundidade a ${curso.title} - objetivos, plano curricular, saídas profissionais e muito mais.`}
        backgroundImage={require('../../assets/BannerANU_ispa.jpg')}
        backgroundId="cursos-Banner"
      />
      
      {/* Barra de navegação */}
      <div style={{ background: "#f5f6fa", padding: "16px 0 8px 0" }}>
        <Container>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb" style={{ background: "transparent", marginBottom: 0 }}>
              <li className="breadcrumb-item">
                <a href="/" style={{ color: "#00761F", textDecoration: "none" }}>Home</a>
              </li>
              <li className="breadcrumb-item">
                <a href="/licenciaturas" style={{ color: "#00761F", textDecoration: "none" }}>Cursos</a>
              </li>
              <li className="breadcrumb-item active" aria-current="page" style={{ color: "#222" }}>
                {curso.title}
              </li>
            </ol>
          </nav>
        </Container>
      </div>

      <header id='header'>
        <AppHeader />
      </header>

      <Container style={{ paddingTop: "50px", paddingBottom: "50px" }}>
        <Row className="g-4">
          {/* Conteúdo Principal */}
          <Col lg={8}>
            <Card className="mb-4" style={{ border: "none", borderRadius: "12px", boxShadow: "0 4px 20px rgba(0,0,0,0.08)" }}>
              <Card.Body style={{ padding: "40px" }}>
                <h2 style={{ color: "#00761F", marginBottom: "20px" }}>{curso.title}</h2>
                <p style={{ fontSize: "1.1rem", color: "#666", lineHeight: "1.6" }}>{curso.description}</p>
                <p style={{ fontSize: "1rem", color: "#444", lineHeight: "1.6" }}>{curso.detalhes}</p>

                {/* Objetivos do Curso */}
                <div style={{ marginTop: "30px" }}>
                  <h4 style={{ color: "#00761F", marginBottom: "20px" }}> Objetivos do Curso</h4>
                  <ul style={{ paddingLeft: "20px" }}>
                    {curso.objetivos.map((objetivo, index) => (
                      <li key={index} style={{ marginBottom: "10px", color: "#444" }}>{objetivo}</li>
                    ))}
                  </ul>
                </div>
                
                <div style={{ marginTop: "30px" }}>
                  <PlanoCurricularSection 
                    planoCurricular={curso.planoCurricularCompleto}
                    cursoTitle={curso.title}
                  />
                </div>

              </Card.Body>
            </Card>
          </Col>

          {/* Sidebar com Informações Adicionais */}
          <Col lg={4}>
            <Card style={{ border: "none", borderRadius: "12px", boxShadow: "0 4px 20px rgba(0,0,0,0.08)", position: "sticky", top: "20px" }}>
              <Card.Body style={{ padding: "30px" }}>
                <h5 style={{ color: "#00761F", marginBottom: "25px", textAlign: "center" }}>Informações do Curso</h5>
                
                {/* Duração */}
                <div style={{ marginBottom: "20px" }}>
                  <h6 style={{ color: "#00761F", marginBottom: "8px" }}>
                    <i className="fas fa-clock me-2"></i>
                    Duração
                  </h6>
                  <p style={{ color: "#444", margin: 0 }}>{curso.duration}</p>
                </div>

                {/* Requisitos */}
                <div style={{ marginBottom: "20px" }}>
                  <h6 style={{ color: "#00761F", marginBottom: "8px" }}>
                    <i className="fas fa-graduation-cap me-2"></i>
                    Requisitos
                  </h6>
                  <p style={{ color: "#444", margin: 0 }}>{curso.requisitos}</p>
                </div>

                {/* Botão de Inscrição */}
                <Button
                  href={curso.linkInscricao}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    backgroundColor: "#00761F",
                    border: "none",
                    borderRadius: "25px",
                    padding: "12px 30px",
                    fontWeight: "600",
                    fontSize: "1rem",
                    width: "100%",
                    marginBottom: "15px",
                    transition: "all 0.3s ease"
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = "#ffffff";
                    e.target.style.color = "#00761F";
                    e.target.style.border = "2px solid #00761F";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = "#00761F";
                    e.target.style.color = "#ffffff";
                    e.target.style.border = "2px solid #00761F";
                  }}
                >
                  <i className="fas fa-edit me-2"></i>
                  Inscreva-se Agora
                </Button>

                <Button
                  variant="outline-success"
                  onClick={() => navigate("/programas/licenciatura")}
                  style={{
                    borderRadius: "25px",
                    padding: "12px 30px",
                    fontWeight: "600",
                    fontSize: "1rem",
                    width: "100%",
                    borderColor: "#00761F",
                    color: "#00761F",
                    transition: "all 0.3s ease"
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = "#00761F";
                    e.target.style.color = "#ffffff";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = "transparent";
                    e.target.style.color = "#00761F";
                  }}
                >
                  <i className="fas fa-arrow-left me-2"></i>
                  Voltar aos Cursos
                </Button>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>

      <AppLayout />
    </div>
  );
}